<template>
    <div class="px-3 py-2">
        <v-form
            ref="forinv"
            lazy-validation
        >
        <b-sidebar id="add_invoice" no-header backdrop width="95%"  :style="`direction:`+lang.ldir" right :title="lang.add_direct_invoice" aria-labelledby="myId" shadow @close="beforeClose()">
    <template #default="{ hide }">
      <div class="m-1 text-start" style="direction:rtl">
        <div style="width:140px;margin-right:10px;background:#000;color:#FFF;border-radius:5px" class="btn-primary btn-sm text-center">
          <span id="myId">{{ lang.add_invoice}}</span>
        </div>
        <div @click="hide" id="HideInvoice" style="width:100px;text-align:center;float:left;margin-left:5px;margin-top:-25px;cursor:pointer" class="btn-danger btn-sm">
          <span>{{ lang.close}}</span>
      </div>
    </div>
            <v-divider></v-divider>
        <div class="px-3 py-2" style="direction:rtl">
            <div class="invoice-tab-wrap">
                <button
                    type="button"
                    class="btn btn-sm invoice-tab-btn"
                    :class="activeInvoiceTab === 'customer_car' ? 'btn-primary' : 'btn-outline-primary'"
                    @click="activeInvoiceTab = 'customer_car'"
                >
                    {{ lang.customer_name }} / {{ lang.car_info }}
                </button>
                <button
                    type="button"
                    class="btn btn-sm invoice-tab-btn"
                    :class="activeInvoiceTab === 'other' ? 'btn-primary' : 'btn-outline-primary'"
                    @click="activeInvoiceTab = 'other'"
                >
                    {{ lang.invoice_details }} / {{ lang.action || 'Other' }}
                </button>
            </div>
            <div v-if="customer.id == 0 && $store.state.licenseType.showCustomerTypes" v-show="activeInvoiceTab === 'customer_car'" class="tobbuttom backBlack" :style="`direction:${ lang.dir};padding:7px;width:100%;text-align:center;`">
                <b-button :style="`border-radius:0;background:transparent;color:#000;border:none;`">{{ lang.customer_type}}</b-button>
                <b-button style="margin-inline-end:5px;font-weight: bolder;width:150px;font-size:1.1rem !important;margin-inline-end:5px;border:2px solid #fff !important" id="_cInd" :class="`dispFlex btn btn-small redColor borderRad_`+lang.algin" @click="changeCusType(0)" >{{ lang.individual_client}} <i id="_indiv"  style="font-size:1.1rem !important;margin-inline-start:10px;" class="fas fa-arrow-down"></i></b-button>
                <b-button style="margin-inline-end:5px;font-weight: bolder;width:150px;font-size:1.1rem !important;border:2px solid #fff !important" id="_cCom" :class="`dispFlex btn btn-small weightColor borderRad_none`" @click="changeCusType(1)" >{{ lang.company_clinet}} <i id="_comps"  style="font-size:1.1rem !important;margin-inline-start:10px;" class="fas fa-arrow-down hideme"></i></b-button>
                <b-button style="margin-inline-end:5px;font-weight: bolder;width:150px;font-size:1.1rem !important;border:2px solid #fff !important" id="_cGov" :class="`dispFlex btn btn-small weightColor borderRad_`+lang.lalgin" @click="changeCusType(2)" >{{ lang.government_clinet}} <i id="_goves" style="font-size:1.1rem !important;margin-inline-start:10px;" class="fas fa-arrow-down hideme"></i></b-button>
            </div>
            <v-row v-show="activeInvoiceTab === 'other'">
                <v-col cols="12" md="1" sm="5" xs="12">
                    <label>{{ lang.invoice_type}}</label>
                    <b-input-group>
                    <b-form-select
                        class="selborder"
                        v-model="invoice.invtype"
                        :options="invtypes"
                        :label="lang.invoice_type"
                        @change="InvType()"
                        style="background:green !important"
                        ></b-form-select>
                    <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                        <i class="fas fa-arrow-down"></i>
                        </b-input-group-append>
                    </b-input-group>
                </v-col>
                <v-col cols="12" md="2" sm="6" xs="12">
                    <label>{{ lang.vat_type}}</label>
                    <b-input-group>
                    <b-form-select
                        class="selborder"
                        v-model="invoice.vtype"
                        :options="vattype"
                        :label="lang.vat_type"
                        @change="changeVatType()"
                        style="background:red !important"
                        ></b-form-select>
                        <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                        <i class="fas fa-arrow-down"></i>
                        </b-input-group-append>
                    </b-input-group>
                </v-col>
                <v-col cols="12" md="2" sm="6" xs="12">
                    <label>{{ lang.payment_method}}</label>
                    <b-input-group>
                    <b-form-select
                        class="selborder"
                        v-model="invoice.paytype"
                        :options="invoice.paytypes"
                        :label="lang.payment_method"
                        @change="changePtype()"
                        ></b-form-select>
                    <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                        <i class="fas fa-arrow-down"></i>
                        </b-input-group-append>
                    </b-input-group>
                </v-col>

                <v-col cols="12" md="1" sm="6" xs="12">
                    <label>{{ lang.saler_name}}</label>
                    <b-input-group>
                    <b-form-select
                        class="selborder"
                        v-model="invoice.userid"
                        :options="invoice.users"
                        :label="lang.saler_name"
                        ></b-form-select>
                    <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                        <i class="fas fa-arrow-down"></i>
                        </b-input-group-append>
                    </b-input-group>
                </v-col>
                <v-col cols="12" md="2" sm="6" xs="12" v-if="$store.state.caneditinvoicedate">
                    <label>{{ lang.invoice_date}}</label>
                    <div class="flexTay">
                        <b-form-select class="inborder text-center" style="width:30%;background:#efefef;" v-model="sd.day" :options="$store.state.daysList"/>
                        <b-form-select class="inborder text-center" style="width:30%;background:#efefef;" v-model="sd.month" :options="$store.state.monthsList" />
                        <b-form-select class="inborder text-center" style="width:60%;background:#efefef;" v-model="sd.year" :options="$store.state.yearList" />
                    </div>
                </v-col>
                <v-col cols="12" md="3" sm="6" xs="12" v-else>
                    <label>{{ lang.invoice_date}}</label>
                    <b-form-input
                        class="inborder"
                            v-model="invoice.date"
                            :label="lang.invoice_date"
                            prepend-icon="mdi-calendar"
                            readonly
                        >{{ invoice.date }}</b-form-input>
                </v-col>
                <v-col cols="12" md="1" sm="6" xs="12" v-if="$store.state.licenseType.permCostCenter">
                    <label>{{ lang.costCenter}}</label>
                    <b-input-group>
                    <b-form-select
                        class="selborder"
                        v-model="invoice.cost_center"
                        :options="costCenters"
                        ></b-form-select>
                    <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                        <i class="fas fa-arrow-down"></i>
                        </b-input-group-append>
                    </b-input-group>
                </v-col>
                <v-col cols="12" md="1" sm="6" xs="12">
                    <label>{{ lang.chose_store}}</label>
                    <b-input-group>
                    <b-form-select
                        class="selborder"
                        v-model="invoice.store_id"
                        :options="storeIds"

                        ></b-form-select>
                    <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                        <i class="fas fa-arrow-down"></i>
                        </b-input-group-append>
                    </b-input-group>
                </v-col>
                <v-col cols="12" md="2" sm="4" xs="12" v-if="$store.state.licenseType.cars && $store.state.licenseType.showCarNumber">

                    <label>{{ lang.carsnumber}}</label>
                    <b-input-group>
                        <b-form-select
                            class="selborder"
                            v-model="invoice.carsnumber"
                            :options="carsNums"
                            @change="updateCarsCount()"
                            style="background:rergb(255, 136, 0) !important"
                            ></b-form-select>
                        <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                            <i class="fas fa-arrow-down"></i>
                        </b-input-group-append>
                    </b-input-group>
                </v-col>
                <v-col cols="12" md="2" sm="6" xs="12">
                    <label>{{ lang.work_type}}</label>
                    <b-input-group>
                    <b-form-select
                        class="selborder"
                        v-model="invoice.work_type"
                        :options="workTypes"
                        :label="lang.invoice_type"
                        @change="InvType()"
                        style="background:black !important"
                        ></b-form-select>
                    <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                        <i class="fas fa-arrow-down"></i>
                        </b-input-group-append>
                    </b-input-group>
                </v-col>
            </v-row>

            <v-row v-if="$store.state.licenseType.isCar">
                <v-col cols="12" md="3" sm="6" xs="12">
                    <label>{{ lang.maint_start_date }}</label>
                    <b-form-input
                        class="inborder"
                        type="date"
                        v-model="invoice.maint_start_date"
                    ></b-form-input>
                </v-col>
                <v-col cols="12" md="3" sm="6" xs="12">
                    <label>{{ lang.maint_end_date }}</label>
                    <b-form-input
                        class="inborder"
                        type="date"
                        v-model="invoice.maint_end_date"
                    ></b-form-input>
                </v-col>
                <v-col cols="12" md="3" sm="6" xs="12">
                    <label>{{ lang.policy_number }}</label>
                    <b-form-input
                        class="inborder"
                        type="text"
                        v-model="invoice.policy_number"
                    ></b-form-input>
                </v-col>
            </v-row>

            <v-row style="display:none;" v-if="customer.cctype == 1 && ($store.state.licenseType.cars || $store.state.licenseType.bill) && activeInvoiceTab === 'customer_car'">
                <v-col cols="12" md="1" sm="12" style="display:none !important;">
                    <label>{{ lang.invoiceno}}</label>
                    <b-form-input
                        class="inborder"
                        :label="lang.invoiceno"
                        v-model="invoice.billid"
                        :rules="fieldRules"
                        required
                        readonly
                    >{{ invoice.billid }}</b-form-input>
                </v-col>
                <v-col cols="12" md="2" sm="4" xs="12" v-if="$store.state.licenseType.showIDNumber">
                    <label>{{ lang.customerid}}</label>
                    <b-form-input
                        class="inborder"
                        :label="lang.customerid"
                        v-model="customer.customerid"
                        size="10"
                        id="CusMobile"
                        @change="getAllNameById(0)"
                        >{{ customer.mobile }}</b-form-input>
                </v-col>
                <v-col cols="12" md="2" sm="4" xs="12">
                    <label>{{ lang.mobile}}</label>
                    <b-form-input
                        class="inborder"
                        :label="lang.mobile"
                        v-model="customer.mobile"
                        size="10"
                        id="CusMobile"
                        @change="getName(1)"
                        >{{ customer.mobile }}</b-form-input>
                </v-col>
                <v-col cols="12" md="2" sm="4" xs="12">
                    <label>{{ lang.id_number}}</label>
                    <b-form-input
                        class="inborder"
                        :label="lang.id_number"
                        v-model="customer.id_number"
                        size="10"
                        id="CusMobile"
                        ></b-form-input>
                </v-col>
                <v-col cols="12" md="2" sm="8" xs="12" style="display:none;">
                    <label>{{ lang.chose_customer}}</label>
                    <b-input-group>
                        <b-form-select
                            class="selborder"
                            v-model="customer.id"
                            :options="customerLists"
                            @change="selectCustomer()"
                            style="background:red !important"
                            ></b-form-select>
                        <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                            <i class="fas fa-arrow-down"></i>
                        </b-input-group-append>
                    </b-input-group>
                </v-col>
                <v-col cols="12" md="2" sm="8" xs="12">
                    <label>{{ lang.customer_name}}</label>
                    <b-form-input
                        class="inborder"
                        :label="lang.customer_name"
                        v-model="customer.full_name"
                        id="CusMobile"
                        >{{ customer.full_name }}</b-form-input>
                </v-col>
                <v-col cols="12" md="2" sm="8" xs="12" v-if="$store.state.licenseType.showOwnerName">
                    <label>{{ lang.owner_name}}</label>
                    <b-form-input
                        class="inborder"
                        :label="lang.owner_name"
                        v-model="invoice.owner_name"
                        >{{ invoice.owner_name }}</b-form-input>
                </v-col>

            </v-row>
            <v-row v-if="!showcamp && !showGov && activeInvoiceTab === 'customer_car'">
                <v-col cols="12" md="2" sm="12" style="display:none !important;">
                    <label>{{ lang.invoiceno}}</label>
                    <b-form-input
                        class="inborder"
                        :label="lang.invoiceno"
                        v-model="invoice.billid"
                        :rules="fieldRules"
                        required
                        readonly
                    >{{ invoice.billid }}</b-form-input>
                </v-col>
                <v-col cols="12" md="2" sm="4" xs="12">
                    <label>{{ lang.customerid}}</label>
                    <b-form-input
                        class="inborder"
                        :label="lang.customerid"
                        v-model="customer.customerid"
                        size="10"
                        @change="getAllNameById(0)"
                        >{{ customer.customerid }}</b-form-input>
                </v-col>
                <v-col cols="12" md="2" sm="4" xs="12">
                    <label>{{ lang.mobile}}</label>
                    <b-form-input
                        class="inborder"
                        :label="lang.mobile"
                        v-model="customer.mobile"
                        :rules="fieldRules"
                        size="10"
                        id="CusMobile"
                        @change="getName()"
                        >{{ customer.mobile }}</b-form-input>
                </v-col>
                <v-col cols="12" md="4" sm="8" xs="12">
                   <label>{{ lang.customer_name}}</label>
                    <b-form-input
                        class="inborder"
                        :label="lang.customer_name"
                        v-model="customer.full_name"
                        :rules="fieldRules"
                        >{{ customer.full_name }}</b-form-input>
                </v-col>


            </v-row>
            <v-row v-if="showcamp && activeInvoiceTab === 'customer_car'">
                <v-col cols="12" md="1" sm="12" style="display:none !important;">
                    <label>{{ lang.invoiceno}}</label>
                    <b-form-input
                        class="inborder"
                        :label="lang.invoiceno"
                        v-model="invoice.billid"
                        :rules="fieldRules"
                        required
                        readonly
                    >{{ invoice.billid }}</b-form-input>
                </v-col>

                <v-col cols="12" md="2" sm="4" xs="12" v-if="$store.state.licenseType.showIDNumber">
                    <label>{{ lang.customerid}}</label>
                    <b-form-input
                        class="inborder"
                        :label="lang.customerid"
                        v-model="customer.customerid"
                        size="10"
                        id="CusMobile"
                        @change="getAllNameById(0)"
                        >{{ customer.customerid }}</b-form-input>
                </v-col>
                <v-col cols="12" md="2" sm="4" xs="12">
                    <label>{{ lang.mobile}}</label>
                    <b-form-input
                        class="inborder"
                        :label="lang.mobile"
                        v-model="customer.mobile"
                        size="10"
                        id="CusMobile"
                        @change="getName(1)"
                        >{{ customer.mobile }}</b-form-input>
                </v-col>
                <v-col cols="12" md="2" sm="8" xs="12" style="display:none;">
                    <label>{{ lang.chose_company}}</label>
                    <b-input-group>
                        <b-form-select
                            class="selborder"
                            v-model="customer.id"
                            :options="customerLists"
                            @change="selectCustomer()"
                            style="background:red !important"
                            ></b-form-select>
                        <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                            <i class="fas fa-arrow-down"></i>
                        </b-input-group-append>
                    </b-input-group>
                </v-col>
                <v-col cols="12" md="2" sm="8" xs="12" style="display:none;">
                    <label>{{ lang.customer_name}}</label>
                    <b-form-input
                        class="inborder"
                        :label="lang.customer_name"
                        v-model="customer.full_name"
                        id="CusMobile"
                        >{{ customer.full_name }}</b-form-input>
                </v-col>
                <v-col cols="12" md="2" sm="12" xs="12" v-if="$store.state.licenseType.showproject">
                    <label>{{ lang.projectname}}</label>
                    <b-form-input
                        class="inborder"
                        :label="lang.projectname"
                        v-model="company.projectname"
                        >{{ company.projectname }}</b-form-input>
                </v-col>
                <v-col cols="12" md="3" sm="12" xs="12">
                     <label>{{ lang.company_name}}</label>
                    <b-form-input
                        class="inborder"
                        :label="lang.company_name"
                        v-model="company.fullname"
                        style="background:#fff700 !important;"
                        />
                </v-col>
                <v-col cols="12" md="2" sm="12" xs="12">
                    <label>{{ lang.company_vatid}}</label>
                    <b-form-input
                        class="inborder"
                        :label="lang.company_vatid"
                        v-model="company.vatid"
                        >{{ company.fullname }}</b-form-input>
                </v-col>
                <v-col cols="12" md="2" sm="12" xs="12">
                    <label>{{ lang.crt_number}}</label>
                    <b-form-input
                        class="inborder"
                        :label="lang.crt_number"
                        v-model="company.crt_number"
                        style=""
                        />
                </v-col>
                <v-col cols="12" md="2" sm="12">
                    <label>{{ lang.street_name}}</label>
                    <b-form-input
                    class="inborder"
                    :label="lang.street_name"
                    v-model="company.street_name"
                    style="background:#d3ffd3 !important"
                    >{{ company.street_name }}</b-form-input>
                </v-col>
                <v-col cols="12" md="1" sm="12">
                    <label>{{ lang.building_no}}</label>
                    <b-form-input
                        class="inborder"
                        :label="lang.building_no"
                        v-model="company.building_no"
                        style="background:#d3ffd3 !important"
                        >{{ company.building_no }}</b-form-input>
                </v-col>
                <v-col cols="12" md="1" sm="12">
                    <label>{{ lang.branch_number}}</label>
                    <b-form-input
                        class="inborder"
                        :label="lang.branch_number"
                        v-model="company.branch_number"
                        style="background:#d3ffd3 !important"
                        >{{ company.branch_number }}</b-form-input>
                </v-col>
                <v-col cols="12" md="2" sm="12">
                    <label>{{ lang.district}}</label>
                    <b-form-input
                        class="inborder"
                        :label="lang.district"
                        v-model="company.district"
                        style="background:#d3ffd3 !important"
                        >{{ company.district }}</b-form-input>
                </v-col>
                <v-col cols="12" md="1" sm="12">
                    <label>{{ lang.zipcode}}</label>
                    <b-form-input
                        class="inborder"
                        :label="lang.zipcode"
                        v-model="company.zipcode"
                        style="background:#d3ffd3 !important"
                        >{{ company.zipcode }}</b-form-input>
                </v-col>
                <v-col cols="12" md="2" sm="12">
                    <label>{{ lang.city}}</label>
                    <b-form-input
                        class="inborder"
                        :label="lang.city"
                        v-model="company.city"
                        style="background:#d3ffd3 !important"
                        >{{ company.city }}</b-form-input>
                </v-col>
                <v-col cols="12" md="3" sm="12" xs="12">
                    <label>{{ lang.comapny_address}}</label>
                    <b-form-input
                        class="inborder"
                        :label="lang.comapny_address"
                        v-model="company.address"
                        style="background:#fff700 !important;"
                        />
                </v-col>

                <v-col cols="12" md="2" sm="12" xs="12">
                    <label>{{ lang.po_number}}</label>
                    <b-form-input
                        class="inborder"
                        :label="lang.po_number"
                        v-model="company.po_number"
                        ></b-form-input>
                </v-col>
                <v-col cols="12" md="2" sm="12" xs="12">
                        <label>{{ lang.po_date}}</label>
                        <div class="flexTay">
                            <b-form-select class="inborder text-center" style="width:30%;background:#efefef;" v-model="cd.day" :options="$store.state.daysList"/>
                            <b-form-select class="inborder text-center" style="width:30%;background:#efefef;" v-model="cd.month" :options="$store.state.monthsList" />
                            <b-form-select class="inborder text-center" style="width:60%;background:#efefef;" v-model="cd.year" :options="$store.state.yearList" />
                        </div>
                        <!-- <b-form-input
                            id="input-live"
                            v-model="company.po_date"
                            aria-describedby="input-live-help input-live-feedback"
                            prepend-icon="mdi-calendar"
                            :placeholder="lang.po_date"
                            type="date"
                            trim
                            v-bind="attrs"
                            v-on="on"
                            class="input-sm inborder"
                        ></b-form-input> -->
                </v-col>
                <v-col cols="12" md="2" sm="12" v-if="$store.state.licenseType.carInsuranceContract">
                    <label>{{ lang.afforded_customer_name }}</label>
                    <b-form-input v-model="invoice.customer_name" class="inborder"></b-form-input>
                </v-col>
                <v-col cols="12" md="2" sm="12" v-if="$store.state.licenseType.carInsuranceContract">
                    <label>{{ lang.customer_afforded }}</label>
                    <b-form-input v-model="invoice.customer_afforded" class="inborder"></b-form-input>
                </v-col>
                <v-col cols="12" md="2" sm="12" v-if="$store.state.licenseType.carInsuranceContract">
                    <label>{{ lang.consumption_value }}</label>
                    <b-form-input v-model="invoice.consumption_fees" class="inborder"></b-form-input>
                </v-col>
                <v-col cols="12" md="2" sm="12" v-if="$store.state.licenseType.carInsuranceContract">
                    <label>{{ lang.consumption_rate }}</label>
                    <b-input-group>
                    <b-form-select
                        class="selborder"
                        v-model="invoice.consumption_rate"
                        :options="consumptionRate"
                        style="background:red !important"
                        @change="calcAll()"
                        ></b-form-select>
                        <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                            <i class="fas fa-arrow-down"></i>
                        </b-input-group-append>
                    </b-input-group>
                </v-col>
            </v-row>
            <v-row v-if="showGov && activeInvoiceTab === 'customer_car'">
                <v-col cols="12" md="1" sm="12" style="display:none !important;">
                    <label>{{ lang.invoiceno}}</label>
                    <b-form-input
                        class="inborder"
                        :label="lang.invoiceno"
                        v-model="invoice.billid"
                        :rules="fieldRules"
                        required
                        readonly
                    >{{ invoice.billid }}</b-form-input>
                </v-col>
                <v-col cols="12" md="2" sm="4" xs="12" v-if="$store.state.licenseType.showIDNumber">
                    <label>{{ lang.customerid}}</label>
                    <b-form-input
                        class="inborder"
                        :label="lang.customerid"
                        v-model="customer.customerid"
                        size="10"
                        id="CusMobile"
                        @change="getAllNameById(0)"
                        >{{ customer.mobile }}</b-form-input>
                </v-col>
                <v-col cols="12" md="2" sm="4" xs="12">
                    <label>{{ lang.mobile}}</label>
                    <b-form-input
                        class="inborder"
                        :label="lang.mobile"
                        v-model="customer.mobile"
                        size="10"
                        id="CusMobile"
                        @change="getName(1)"
                        >{{ customer.mobile }}</b-form-input>
                </v-col>
                <v-col cols="12" md="2" sm="8" xs="12" style="display:none;">
                    <label>{{ lang.chose_entity}}</label>
                    <b-input-group>
                        <b-form-select
                            class="selborder"
                            v-model="customer.id"
                            :options="customerLists"
                            @change="selectCustomer()"
                            style="background:red !important"
                            ></b-form-select>
                        <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                            <i class="fas fa-arrow-down"></i>
                        </b-input-group-append>
                    </b-input-group>
                </v-col>
                <v-col cols="12" md="2" sm="8" xs="12" style="display:none;">
                    <label>{{ lang.customer_name}}</label>
                    <b-form-input
                        class="inborder"
                        :label="lang.customer_name"
                        v-model="customer.full_name"
                        id="CusMobile"
                        >{{ customer.full_name }}</b-form-input>
                </v-col>
                <v-col cols="12" md="3" sm="12" xs="12">
                    <label>{{ lang.entity_name}}</label>
                    <b-form-input
                        class="inborder"
                        :label="lang.entity_name"
                        v-model="company.entity_name"
                        ></b-form-input>
                </v-col>
                <v-col cols="12" md="2" sm="12" xs="12">
                    <label>{{ lang.branch_name}}</label>
                    <b-form-input
                        class="inborder"
                        :label="lang.branch_name"
                        v-model="company.branch_name"
                        ></b-form-input>
                </v-col>
                <v-col cols="12" md="2" sm="12" xs="12">
                    <label>{{ lang.request_number}}</label>
                    <b-form-input
                        class="inborder"
                        :label="lang.request_number"
                        v-model="company.request_number"
                        ></b-form-input>
                </v-col>
                <v-col cols="12" md="2" sm="12" xs="12">
                    <label>{{ lang.order_number}}</label>
                    <b-form-input
                        class="inborder"
                        :label="lang.order_number"
                        v-model="company.order_number"
                        ></b-form-input>
                </v-col>
                <v-col cols="12" md="2" sm="12" xs="12">
                    <label>{{ lang.po_number}}</label>
                    <b-form-input
                        class="inborder"
                        :label="lang.po_number"
                        v-model="company.po_number"
                        ></b-form-input>
                </v-col>
                <v-col cols="12" md="2" sm="12" xs="12">
                    <label>{{ lang.po_date}}</label>
                        <div class="flexTay">
                            <b-form-select class="inborder text-center" style="width:30%;background:#efefef;" v-model="cd.day" :options="$store.state.daysList"/>
                            <b-form-select class="inborder text-center" style="width:30%;background:#efefef;" v-model="cd.month" :options="$store.state.monthsList" />
                            <b-form-select class="inborder text-center" style="width:60%;background:#efefef;" v-model="cd.year" :options="$store.state.yearList" />
                        </div>
                        <!-- <b-form-input
                            id="input-live"
                            v-model="company.po_date"
                            aria-describedby="input-live-help input-live-feedback"
                            prepend-icon="mdi-calendar"
                            :placeholder="lang.po_date"
                            type="date"
                            trim
                            v-bind="attrs"
                            v-on="on"
                            class="input-sm inborder"
                        ></b-form-input> -->
                </v-col>

            </v-row>
            <div  v-if="($store.state.licenseType.cars || $store.state.licenseType.carinfo) && activeInvoiceTab === 'customer_car'">
                <v-row v-if="customerCarOptions.length > 1" class="mb-2">
                    <v-col cols="12" md="4" sm="12">
                        <label>{{ lang.chose_car }}</label>
                        <b-input-group>
                            <b-form-select
                                class="selborder"
                                :options="customerCarOptions"
                                v-model="selectedCustomerCar"
                                @change="applySelectedCustomerCar()"
                                style="background:#eee !important;color:#000 !important;"
                            ></b-form-select>
                            <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                <i class="fas fa-arrow-down" style="color:#000"></i>
                            </b-input-group-append>
                        </b-input-group>
                    </v-col>
                </v-row>
                <v-row v-for="(item,index) in cars" :key="index">
                    <v-col cols="12">
                        <v-row>
                            <v-col cols="12" md="2" sm="12">
                                <label>{{ lang.plate_number}}</label>
                                <div class="plateNumber" v-if="$store.state.licenseType.SeparatePlate">
                                    <b-form-input class="inborder" v-model="cars[index].c1" @change="plNum(index)" style="background:#fff700 !important;width:30px;background:#efefef;" />
                                    <b-form-input class="inborder" v-model="cars[index].c2" @change="plNum(index)" style="border-inline:none !important;background:#fff700 !important;width:30px;background:#efefef;" />
                                    <b-form-input class="inborder" v-model="cars[index].c3" @change="plNum(index)" style="border-inline-end:none !important;background:#fff700 !important;width:30px;background:#efefef;" />
                                    <b-form-input class="inborder" v-model="cars[index].text" @change="plNum(index)" style="background:#fff700 !important;width:60px;background:#efefef;" />
                                </div>
                                <b-form-input
                                    v-if="$store.state.licenseType.carInfoRequired && !$store.state.licenseType.SeparatePlate"
                                    class="inborder"
                                    v-model="cars[index].plate_number"
                                    @change="getCar(cars[index].plate_number,index)"
                                    style="background:#fff700 !important;"
                                />
                                <b-form-input
                                    v-if="!$store.state.licenseType.SeparatePlate && !$store.state.licenseType.carInfoRequired"
                                    class="inborder"
                                    v-model="cars[index].plate_number"
                                    @change="getCar(cars[index].plate_number,index)"
                                />
                            </v-col>
                            <v-col cols="12" md="2" sm="8" xs="12">
                                <label>{{ lang.brand_name}}</label>
                                <b-form-input
                                    class="inborder"
                                    v-model="cars[index].brand"
                                    ></b-form-input>
                            </v-col>
                            <v-col cols="12" md="2" sm="4" xs="12">
                                <label>{{ lang.car_model}}</label>
                                <b-form-input
                                    v-if="$store.state.licenseType.carInfoRequired"
                                    class="inborder"
                                    v-model="cars[index].model"
                                    style="background:#fff700 !important;"
                                    />
                                <b-form-input
                                    v-else
                                    class="inborder"
                                    v-model="cars[index].model"
                                    />
                            </v-col>
                            <v-col cols="12" md="1" sm="8" xs="12">
                                <label>{{ lang.car_year}}</label>
                                <b-form-input
                                    v-if="$store.state.licenseType.carInfoRequired"
                                    class="inborder"
                                    v-model="cars[index].made_year"
                                    style="background:#fff700 !important;"
                                    />
                                <b-form-input
                                    v-else
                                    class="inborder"
                                    v-model="cars[index].made_year"
                                    />
                            </v-col>
                            <v-col cols="12" md="1" sm="8" xs="12">
                                <label>{{ lang.car_color}}</label>
                                <b-form-input
                                    class="inborder"
                                    v-model="cars[index].color"
                                    />
                            </v-col>
                            <v-col cols="12" md="2" sm="8" xs="12">
                                <label>{{ lang.vin_numebr}}</label>
                                <b-form-input
                                    v-if="$store.state.licenseType.carVinRequired"
                                    class="inborder"
                                    v-model="cars[index].vin"
                                    @input="toUpper(index)"
                                    ></b-form-input>
                                <b-form-input
                                    v-else
                                    class="inborder"
                                    v-model="cars[index].vin"
                                    @input="toUpper(index)"
                                    />
                            </v-col>
                            <v-col cols="12" md="2" sm="8" xs="12">
                                <label>{{ lang.engine_meter}}</label>
                                <b-form-input
                                    class="inborder"
                                    v-model="cars[index].engine_meter"
                                    />
                            </v-col>
                            <!--
                            <v-col cols="12" md="2" sm="8" xs="12">
                                <label>{{ lang.next_oil_change}}</label>
                                <b-form-input
                                    class="inborder"
                                    :label="lang.next_oil_change"
                                    v-model="cars[index].next_oil_change"
                                    ></b-form-input>
                            </v-col> -->
                        </v-row>
                    </v-col>
                    <!-- <v-col cols="2" v-if="index!=0">
                        <v-btn class="addCar" style="margin-top:28px;border: none !important;box-shadow: none !important;
                            background: red !important;color:#fff !important;width:100%" @click="deleteCar(index)">{{ lang.delete }} <i :class="`fas fa-times`"></i></v-btn>
                    </v-col> -->
                    <!-- <v-col cols="2" v-else>
                        <v-btn class="addCar" style="margin-top:28px;border: none !important;box-shadow: none !important;
                            background: green !important;color:#fff !important;width:100%;" @click="addNewCar()">{{ lang.add_car }} <i :class="`fas fa-arrow-${ lang.lalgin}`"></i></v-btn>
                    </v-col> -->
                </v-row>
                <!-- <div>
                    <v-btn class="boDry" style="color:#fff;border: none;box-shadow: none;
                    background: green;margin-top:3px;font-size:.7rem;" @click="addNewCar()">{{ lang.add_car }}</v-btn>
                </div> -->
            </div>

            <div v-show="activeInvoiceTab === 'other'">
            <v-row class="mt-5">
                <!-- <v-window>{{ lang.invoice_details}}</v-window> -->
                <v-simple-table striped hover style="width:100%;">
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="text-center backBlack" v-if="$store.state.licenseType.cars && $store.state.licenseType.showCarPlate">{{ lang.chose_car}}</th>
                                <th class="text-center backBlack">{{ lang.item_type_label }}</th>
                                <th class="backBlack" v-if="$store.state.licenseType.showItemCode">{{ lang.item_code}}</th>
                                <th style="width:20%" class="text-center backBlack" v-if="$store.state.licenseType.cars || $store.state.licenseType.carinfo">{{ lang.ment_description}}</th>
                                <th style="width:20%" class="text-center backBlack" v-else>{{ lang.description}}</th>

                                <th v-if="$store.state.licenseType.showExtra" class="text-center backBlack">{{ lang.width}}</th>
                                <th v-if="$store.state.licenseType.showExtra" class="text-center backBlack">{{ lang.thickness}}</th>
                                <th v-if="$store.state.licenseType.showExtra" class="text-center backBlack">{{ lang.limited}}</th>

                                <th class="text-center backBlack">{{ lang.qtty}}</th>
                                <th class="text-center backBlack">{{ lang.unit_label }}</th>
                                <th class="text-center backBlack">{{ lang.item_price}}</th>
                                <th class="text-center backBlack">{{ lang.total_without_vat}}</th>
                                <th class="text-center backBlack">{{ lang.vat}}</th>
                                <th class="text-center backBlack">{{ lang.ftotal}}</th>
                                <th class="text-center backBlack" v-if="cardid == 0">{{ lang.action}}</th>
                            </tr>
                        </thead>
                        <tbody id="tablerow">
                            <tr v-for="(item,index) in tbrows" :key="index">
                                <td v-if="$store.state.licenseType.cars && $store.state.licenseType.showCarPlate">{{ item.plate_number }}</td>
                                <td>
                                    <b-input-group>
                                    <b-form-select
                                        class="selborder"
                                        style="background:red !important"
                                        :options="staticOptions.itemTypes"
                                        v-model="tbrows[index].type_of_item">
                                    </b-form-select>
                                    <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                        <i class="fas fa-arrow-down"></i>
                                        </b-input-group-append>
                                    </b-input-group>
                                </td>
                                <td v-if="$store.state.licenseType.showItemCode">{{ item.itemcode }}</td>
                                <td><b-form-input v-model="tbrows[index].item_name" /></td>
                                <td v-if="$store.state.licenseType.showExtra"><b-form-input v-model="tbrows[index].extra1" /></td>
                                <td v-if="$store.state.licenseType.showExtra"><b-form-input v-model="tbrows[index].extra2" /></td>
                                <td v-if="$store.state.licenseType.showExtra"><b-form-input v-model="tbrows[index].extra3" /></td>
                                <td><b-form-input v-model="tbrows[index].qty" @change="changeVatType()" /></td>
                                <td>
                                    <b-input-group>
                                    <b-form-select
                                        class="selborder"
                                        v-model="tbrows[index].unitid"
                                        :options='unitOptions'
                                        style="background:black !important"
                                        ></b-form-select>
                                    <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                        <i class="fas fa-arrow-down"></i>
                                        </b-input-group-append>
                                    </b-input-group>
                                </td>
                                <td><b-form-input v-model="tbrows[index].item_price" @change="changeVatType()" /></td>
                                <td class="text-center" style="background:lightgreen !important">{{ convertToComa(item.total) }}</td>
                                <td class="text-center" style="background:lightgreen !important">{{ convertToComa(item.vat) }}</td>
                                <td class="text-center">{{ convertToComa(item.ftotal) }}</td>
                                <td style="" v-if="cardid == 0">
                                    <b-button type="button" variant="danger" style="padding:0.15rem 0.5rem !important;font-weight:bolder;width:80px;background:red;border:none" @click="removeItem(index)">{{ lang.delete_button }}</b-button>
                                </td>
                            </tr>
                            <tr v-if="cardid == 0">
                                <td v-if="$store.state.licenseType.cars && $store.state.licenseType.showCarPlate" style="width:150px;display:none;">
                                    <b-input-group>
                                    <b-form-select
                                        class="selborder"
                                        style="background:red !important"
                                        :options="currentCars"
                                        v-model="newrow.plate_number">
                                    </b-form-select>
                                    <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                        <i class="fas fa-arrow-down"></i>
                                        </b-input-group-append>
                                    </b-input-group>
                                </td>
                                <td v-if="$store.state.licenseType.cars && $store.state.licenseType.showCarPlate" style="width:150px;">
                                    <b-input-group>
                                    <b-form-select
                                        class="selborder"
                                        style="background:red !important"
                                        :options="currentCars"
                                        v-model="newrow.plate_number">
                                    </b-form-select>
                                    <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                        <i class="fas fa-arrow-down"></i>
                                        </b-input-group-append>
                                    </b-input-group>
                                </td>
                                <td style="width:150px;">
                                    <b-input-group>
                                    <b-form-select
                                        class="selborder"
                                        style="background:red !important"
                                        :options="staticOptions.itemTypes"
                                        v-model="newrow.type_of_item">
                                    </b-form-select>
                                    <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                        <i class="fas fa-arrow-down"></i>
                                        </b-input-group-append>
                                    </b-input-group>
                                </td>
                                <td style="width:150px;" v-if="$store.state.licenseType.showItemCode">
                                    <b-form-input
                                        class="inborder"
                                        v-model="newrow.itemcode"
                                        @change="getProducts()"
                                        >
                                    </b-form-input>
                                </td>
                                <td>
                                    <b-form-input v-model="newrow.item_name" list="items-list1" @input="searchItemsLazy(newrow.item_name)" @change="changeMe()"></b-form-input>
                                    <datalist id="items-list1">
                                        <option v-for="(item,index) in itemsworkdes" :key="index">{{item.item_code}} -||- {{item[`item_name`+lang.langname]}}</option>
                                    </datalist>

                                    <div>
                                        <b-form-textarea class="inborder" style="display:none !important;" v-model="newrow.description" />
                                    </div>

                                </td>
                                <td v-if="$store.state.licenseType.showExtra">
                                    <b-form-input
                                        class="inborder"
                                        v-model="newrow.extra1"
                                    ></b-form-input>
                                </td>
                                <td v-if="$store.state.licenseType.showExtra">
                                    <b-form-input
                                        class="inborder"
                                        v-model="newrow.extra2"
                                    ></b-form-input>
                                </td>
                                <td v-if="$store.state.licenseType.showExtra">
                                    <b-form-input
                                        class="inborder"
                                        v-model="newrow.extra3"
                                    ></b-form-input>
                                </td>
                                <td>
                                    <b-form-input
                                        class="inborder"
                                        v-model="newrow.qty"
                                        @change="calcKit()"
                                        id="newitemqty"
                                    ></b-form-input>
                                </td>
                                <td style="width:100px;">
                                    <b-input-group>
                                    <b-form-select
                                        class="selborder"
                                        v-model="newrow.unitid"
                                        :options='unitOptions'
                                        style="background:black !important"
                                        ></b-form-select>
                                    <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                        <i class="fas fa-arrow-down"></i>
                                        </b-input-group-append>
                                    </b-input-group>

                                </td>
                                <td>
                                    <b-form-input
                                        class="inborder"
                                        v-model="newrow.item_price"
                                        @change="calcKit()"
                                    ></b-form-input>
                                </td>
                                <td>
                                    <b-form-input
                                        class="inborder"
                                        v-model="newrow.total"
                                        @change="calcKit()"
                                        readonly
                                    ></b-form-input>
                                </td>
                                <td>
                                    <b-form-input
                                        class="inborder"
                                        v-model="newrow.vat"
                                        @change="calcKit()"
                                        readonly
                                    ></b-form-input>
                                </td>
                                <td>
                                    <b-form-input
                                        class="inborder"
                                        v-model="newrow.ftotal"
                                        @change="calcKit()"
                                        readonly
                                    ></b-form-input>
                                </td>
                                <td class="text-center" style="">
                                    <b-button type="button" class="btn-sm" variant="success" style="display:none;width:80px;font-weight:bolder;background:green;border:none;" @click="addNewRow()">{{ lang.add}}</b-button>
                                </td>
                            </tr>
                            <tr v-if="cardid == 0 && contractOfferedItems.length">
                                <td colspan="15" style="background:#eef8ee;border:1px solid #7ac47a;padding:6px;">
                                    <div style="font-size:0.85rem;font-weight:bold;color:#1c7a3f;margin-bottom:4px;">{{ lang.contract_covered_items || 'هذه السيارة مشمولة بعقد صيانة سار - أصناف العقد:' }}</div>
                                    <b-button
                                        v-for="(citem, cidx) in contractOfferedItems"
                                        :key="cidx"
                                        size="sm"
                                        variant="outline-success"
                                        style="margin:2px;font-size:0.8rem;"
                                        @click="addContractItem(citem)"
                                    >{{ citem.item_name }} ({{ citem.item_price }})</b-button>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <th v-if="$store.state.licenseType.cars && $store.state.licenseType.showCarPlate" class="text-center backEmpty"></th>
                                <th class="text-center backEmpty" v-if="$store.state.licenseType.showItemCode"></th>
                                <th class="text-center backEmpty"></th>
                                <th class="text-center backEmpty"></th>
                                <th v-if="$store.state.licenseType.showExtra" class="text-center backEmpty"></th>
                                <th v-if="$store.state.licenseType.showExtra" class="text-center backEmpty"></th>
                                <th v-if="$store.state.licenseType.showExtra" class="text-center backEmpty"></th>
                                <th class="text-center backEmpty"></th>
                                <th class="text-center backEmpty"></th>
                                <td class="text-center backBlack"> {{ lang.total_discount}}</td>
                                <td class="text-center backBlack">
                                    <b-form-input
                                        class="inborder"
                                        v-model="invoice.discount"
                                        @change="changeVatType()"
                                        v-if="cardid == 0"

                                    ></b-form-input>
                                    <b-form-input
                                        class="inborder"
                                        v-model="invoice.discount"
                                        v-else

                                        @change="changeVatType()"
                                    ></b-form-input>
                                </td>
                                <td class="text-center backEmpty"></td>
                                <td class="text-center backEmpty"></td>
                                <th class="text-center backEmpty"></th>
                            </tr>
                            <tr>
                                <th class="text-center backEmpty" v-if="$store.state.licenseType.cars && $store.state.licenseType.showCarPlate"></th>
                                <th class="text-center backEmpty" v-if="$store.state.licenseType.showItemCode"></th>
                                <th class="text-center backEmpty"></th>
                                <th class="text-center backEmpty"></th>
                                <th v-if="$store.state.licenseType.showExtra" class="text-center backEmpty"></th>
                                <th v-if="$store.state.licenseType.showExtra" class="text-center backEmpty"></th>
                                <th v-if="$store.state.licenseType.showExtra" class="text-center backEmpty"></th>
                                <th class="text-center backBlack">{{ lang.total}}</th>
                                <th class="text-center backBlack">{{ convertToComa(nsp.total) }}</th>
                                <th class="text-center backBlack">{{ convertToComa(nsp.vat) }}</th>
                                <th class="text-center backBlack">{{ convertToComa(nsp.ftotal) }}</th>
                                <th class="text-center backEmpty" v-if="cardid == 0"></th>
                            </tr>
                            <!-- <tr>
                                <th class="text-center"></th>
                                <th class="text-center"></th>
                                <th class="text-center"> تأمين</th>
                                <th class="text-center">
                                    <b-form-input
                                        class="inborder"
                                        v-model="invoice.insurance"
                                        @change="calcAll()"
                                        type="number"
                                    ></b-form-input>
                                </th>
                                <th class="text-center"></th>
                                <th class="text-center"></th>
                                <th class="text-center"></th>
                            </tr>
                            <tr>
                                <th class="text-center"></th>
                                <th class="text-center"></th>
                                <th class="text-center">الاجمالي بعد التامين</th>
                                <th class="text-center">{{ full_total_in }}</th>
                                <th class="text-center"></th>
                                <th class="text-center"></th>
                                <th class="text-center"></th>
                            </tr> -->
                            <tr v-if="invoice.invtype != 1 && full_total != 0">
                                <td class="backEmpty" v-if="$store.state.licenseType.cars && $store.state.licenseType.showCarPlate"></td>
                                <td class="backEmpty"></td>
                                <td class="backEmpty"></td>
                                <td class="backEmpty"></td>
                                <td v-if="$store.state.licenseType.showExtra" class="backEmpty"></td>
                                <td v-if="$store.state.licenseType.showExtra" class="backEmpty"></td>
                                <td v-if="$store.state.licenseType.showExtra" class="backEmpty"></td>
                                <td class="backEmpty" colspan="4" style="color:#000 !important;">
                                    <label>{{ lang.payment_amount}}</label>
                                    <b-form-input
                                        class="inborder"
                                        :label="lang.payment_amount"
                                        v-model="invoice.payment.cash"
                                        style="background:#c3d9ff;width:150px"
                                        >{{ invoice.payment.cash }}</b-form-input>
                                </td>
                                <td v-if="cardid == 0"></td>
                            </tr>
                        </tfoot>

                    </template>
                </v-simple-table>
            </v-row>


            <v-row class="mt-10" v-if="($store.state.licenseType.cars || $store.state.licenseType.carinfo ) && $store.state.licenseType.showSpare">
                <v-simple-table striped hover style="width:100%;">
                        <thead>
                            <tr>
                                <th colspan="9" class="p-2 text-center">{{ lang.add_spare_part}}</th>
                            </tr>
                        </thead>
                </v-simple-table>
                <br>
                <v-simple-table striped hover style="width:100%;margin-top:10px;">
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="text-center backBlack" v-if="$store.state.licenseType.cars && $store.state.licenseType.showCarPlate">{{ lang.chose_car}}</th>
                                <th class="backBlack" v-if="$store.state.licenseType.showItemCode">{{ lang.spare_part_item_code}}</th>
                                <th style="width:20%" class="text-center backBlack">{{ lang.item_name}}</th>

                                <th v-if="$store.state.licenseType.showExtra" class="text-center backBlack">{{ lang.width}}</th>
                                <th v-if="$store.state.licenseType.showExtra" class="text-center backBlack">{{ lang.thickness}}</th>
                                <th v-if="$store.state.licenseType.showExtra" class="text-center backBlack">{{ lang.limited}}</th>

                                <th class="text-center backBlack">{{ lang.qtty}}</th>
                                <th class="text-center backBlack">{{ lang.unitname}}</th>
                                <th class="text-center backBlack">{{ lang.item_price}}</th>
                                <th class="text-center backBlack">{{ lang.total_without_vat}}</th>
                                <th class="text-center backBlack">{{ lang.vat}}</th>
                                <th class="text-center backBlack">{{ lang.ftotal}}</th>
                                <th class="text-center backBlack" v-if="cardid == 0">{{ lang.action}}</th>
                            </tr>
                        </thead>
                        <tbody id="tablerow">
                            <tr v-for="(item,index) in tbrows1" :key="index">
                                <td v-if="$store.state.licenseType.cars && $store.state.licenseType.showCarPlate">{{ item.plate_number }}</td>
                                <td v-if="$store.state.licenseType.showItemCode">{{ item.itemcode }}</td>
                                <td><b-form-input v-model="tbrows1[index].item_name" /></td>
                                <td v-if="$store.state.licenseType.showExtra"><b-form-input v-model="tbrows1[index].extra1" /></td>
                                <td v-if="$store.state.licenseType.showExtra"><b-form-input v-model="tbrows1[index].extra2" /></td>
                                <td v-if="$store.state.licenseType.showExtra"><b-form-input v-model="tbrows1[index].extra3" /></td>
                                <td><b-form-input v-model="tbrows1[index].qty" @change="changeVatType()" /></td>
                                <td>{{tbrows1[index].unitname}}</td>
                                <td><b-form-input v-model="tbrows1[index].item_price" @change="changeVatType()" /></td>
                                <td class="text-center" style="background:lightgreen !important">{{ convertToComa(item.total) }}</td>
                                <td class="text-center" style="background:lightgreen !important">{{ convertToComa(item.vat) }}</td>
                                <td class="text-center">{{ convertToComa(item.ftotal) }}</td>
                                <td style="" v-if="cardid == 0">
                                    <b-button type="button" variant="danger" style="padding:0.15rem 0.5rem !important;font-weight:bolder;width:80px;background:red;border:none" @click="removeItem1(index)">{{ lang.delete_button }}</b-button>
                                </td>
                            </tr>
                            <tr v-if="cardid == 0">
                                <td v-if="$store.state.licenseType.cars && $store.state.licenseType.showCarPlate" style="width:150px;">
                                    <b-input-group>
                                    <b-form-select
                                        class="selborder"
                                        style="background:red !important"
                                        :options="currentCars"
                                        v-model="newrow1.plate_number">
                                    </b-form-select>
                                    <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                        <i class="fas fa-arrow-down"></i>
                                        </b-input-group-append>
                                    </b-input-group>
                                </td>
                                <td style="width:150px;" v-if="$store.state.licenseType.showItemCode">
                                    <b-form-input
                                        class="inborder"
                                        v-model="newrow1.itemcode"
                                        @change="getProducts()"
                                        >
                                    </b-form-input>
                                </td>
                                <td>
                                    <b-form-input v-model="newrow1.item_name" list="items-list" @input="searchItemsLazy(newrow1.item_name)" @change="changeMe()"></b-form-input>
                                    <datalist id="items-list">
                                        <option v-for="(item,index) in spareparts" :key="index">{{item.item_code}} -||- {{ item[`item_name${ lang.langname}`] }}</option>
                                    </datalist>
                                    <!-- <v-combobox
                                        v-model="newrow1.item_name"
                                        :items="spareparts"
                                        small-chips
                                        v-if="!$store.state.licenseType.requirePurchase"
                                        @change="getItemcode()"
                                    ></v-combobox>
                                    <span v-else>{{ newrow1.item_name }}</span> -->
                                </td>
                                <td v-if="$store.state.licenseType.showExtra">
                                    <b-form-input
                                        class="inborder"
                                        v-model="newrow1.extra1"
                                    ></b-form-input>
                                </td>
                                <td v-if="$store.state.licenseType.showExtra">
                                    <b-form-input
                                        class="inborder"
                                        v-model="newrow1.extra2"
                                    ></b-form-input>
                                </td>
                                <td v-if="$store.state.licenseType.showExtra">
                                    <b-form-input
                                        class="inborder"
                                        v-model="newrow1.extra3"
                                    ></b-form-input>
                                </td>
                                <td>
                                    <b-form-input
                                        class="inborder"
                                        v-model="newrow1.qty"
                                        @change="calcKit1()"
                                        id="newitemqty"
                                    ></b-form-input>
                                </td>
                                <td>
                                    <b-form-select
                                        class="selborder"
                                        v-model="newrow1.unitid"
                                        @change="calcKit1()"
                                        id="newitemqty"
                                    ></b-form-select>
                                </td>
                                <td>
                                    <b-form-input
                                        class="inborder"
                                        v-model="newrow1.item_price"
                                        @change="calcKit1()"
                                    ></b-form-input>
                                </td>
                                <td>
                                    <b-form-input
                                        class="inborder"
                                        v-model="newrow1.total"
                                        @change="calcKit1()"
                                        readonly
                                    ></b-form-input>
                                </td>
                                <td>
                                    <b-form-input
                                        class="inborder"
                                        v-model="newrow1.vat"
                                        @change="calcKit1()"
                                        readonly
                                    ></b-form-input>
                                </td>
                                <td>
                                    <b-form-input
                                        class="inborder"
                                        v-model="newrow1.ftotal"
                                        @change="calcKit1()"
                                        readonly
                                    ></b-form-input>
                                </td>
                                <td class="text-center" style="">
                                    <b-button type="button" class="btn-sm" variant="success" style="display:none;width:80px;font-weight:bolder;background:green;border:none;" @click="addNewRow1()">{{ lang.add}}</b-button>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <!-- <tr>
                                <th v-if="$store.state.licenseType.cars || $store.state.licenseType.carinfo" class="text-center backEmpty"></th>
                                <th class="text-center backEmpty" v-if="$store.state.licenseType.showItemCode"></th>
                                <th class="text-center backEmpty"></th>
                                <th v-if="$store.state.licenseType.showExtra" class="text-center backEmpty"></th>
                                <th v-if="$store.state.licenseType.showExtra" class="text-center backEmpty"></th>
                                <th v-if="$store.state.licenseType.showExtra" class="text-center backEmpty"></th>
                                <th class="text-center backEmpty"></th>
                                <td class="text-center backBlack"> {{ lang.total_discount}}</td>
                                <td class="text-center backBlack">
                                    <b-form-input
                                        class="inborder"
                                        v-model="invoice.discount"
                                        @change="calcAll()"
                                    ></b-form-input>
                                </td>
                                <td class="text-center backEmpty"></td>
                                <td class="text-center backEmpty"></td>
                                <th class="text-center backEmpty"></th>
                            </tr> -->
                            <tr>
                                <th class="text-center backEmpty" v-if="$store.state.licenseType.cars && $store.state.licenseType.showCarPlate"></th>
                                <th class="text-center backEmpty" v-if="$store.state.licenseType.showItemCode"></th>
                                <th class="text-center backEmpty"></th>
                                <th class="text-center backEmpty"></th>
                                <th class="text-center backEmpty"></th>
                                <th v-if="$store.state.licenseType.showExtra" class="text-center backEmpty"></th>
                                <th v-if="$store.state.licenseType.showExtra" class="text-center backEmpty"></th>
                                <th v-if="$store.state.licenseType.showExtra" class="text-center backEmpty"></th>
                                <th class="text-center backBlack">{{ lang.total}}</th>
                                <th class="text-center backBlack">{{ convertToComa(sp.total) }}</th>
                                <th class="text-center backBlack">{{ convertToComa(sp.vat) }}</th>
                                <th class="text-center backBlack">{{ convertToComa(sp.ftotal) }}</th>
                                <th class="text-center backEmpty" v-if="cardid == 0"></th>
                            </tr>
                            <!-- <tr>
                                <th class="text-center"></th>
                                <th class="text-center"></th>
                                <th class="text-center"> تأمين</th>
                                <th class="text-center">
                                    <b-form-input
                                        class="inborder"
                                        v-model="invoice.insurance"
                                        @change="calcAll()"
                                        type="number"
                                    ></b-form-input>
                                </th>
                                <th class="text-center"></th>
                                <th class="text-center"></th>
                                <th class="text-center"></th>
                            </tr>
                            <tr>
                                <th class="text-center"></th>
                                <th class="text-center"></th>
                                <th class="text-center">الاجمالي بعد التامين</th>
                                <th class="text-center">{{ full_total_in }}</th>
                                <th class="text-center"></th>
                                <th class="text-center"></th>
                                <th class="text-center"></th>
                            </tr> -->
                            <!-- <tr v-if="invoice.invtype != 1 && full_total != 0">
                                <td class="backEmpty"></td>
                                <td class="backEmpty"></td>
                                <td class="backEmpty"></td>
                                <td class="backEmpty"></td>
                                <td v-if="$store.state.licenseType.showExtra" class="backEmpty"></td>
                                <td v-if="$store.state.licenseType.showExtra" class="backEmpty"></td>
                                <td v-if="$store.state.licenseType.showExtra" class="backEmpty"></td>
                                <td class="backEmpty" colspan="5" style="color:#000 !important;">
                                    <label>{{ lang.payment_amount}}</label>
                                    <b-form-input
                                        class="inborder"
                                        :label="lang.payment_amount"
                                        v-model="invoice.payment.cash"
                                        style="background:#c3d9ff;width:150px"
                                        >{{ invoice.payment.cash }}</b-form-input>
                                </td>
                            </tr> -->
                        </tfoot>

                    </template>
                </v-simple-table>
            </v-row>

            <v-row>
                <v-col cols="12" md="6" sm="8" xs="12">
                    <label>{{ lang.add_invoice_notes}}</label>
                    <b-form-textarea
                        class="inborder"
                        :label="lang.add_invoice_notes"
                        v-model="invoice.notes"
                        >{{ invoice.notes }}</b-form-textarea>
                </v-col>
                <v-col class="text-center" cols="12" md="6" sm="12" xs="12" v-if="$store.state.licenseType.showSketch">
                    <div class="flexMe">
                        <div class="text-center" style="width:100px;margin:auto">
                            <v-btn style="width:100%;box-shadow:none;color:#fff;background:blue !important;border:1px solid #ccc !important;" @click.prevent="$refs.firstCar.$refs.VueCanvasDrawing.reset()">{{ lang.reset}}</v-btn>
                            <v-btn style="width:100%;box-shadow:none;color:#fff;background:red !important;border:1px solid #ccc !important;" @click.prevent="$refs.firstCar.$refs.VueCanvasDrawing.undo()">{{ lang.undo}}</v-btn>
                            <v-btn style="width:100%;box-shadow:none;color:#fff;background:green !important;border:1px solid #ccc !important;" @click="save()">{{ lang.save}}</v-btn>
                        </div>
                        <div>
                            <div style="width:400px;margin:auto">
                                <b-input-group>
                                    <b-form-select class="selborder" :options="AcurrentCars" v-model="selectedCar" />
                                    <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                        <i class="fas fa-arrow-down"></i>
                                        </b-input-group-append>
                                </b-input-group>
                            </div>
                            <addCarScetch ref="firstCar" :CarsList="AcurrentCars" :carFirst="cars[0].plate_number" />
                        </div>

                    </div>
                </v-col>
            </v-row>
            <div class="flexDis" style="margin-top:15px;">
                <div style="border:1px solid #000;width:33%;margin-inline-end:3px;" v-for="(item,index) in images" :key="index">
                    <div>
                        <img style="width:100%;" :src="item.image" />
                    </div>
                    <div style="border:1px solid #000;background:#000;color:#fff" class="text-center">{{ item.plate }}</div>
                </div>
            </div>
            </div>
        </div>

    </template>

        <template #footer="" class="shadow">
        <div class="d-flex text-light align-items-center px-3 py-5">
          <b-button type="button" @click="addInvoicexO()" v-if="$store.state.licenseType.showApprove" v-b-toggle.invoiceApprove id="addBTN" variant="success" class="ma-2 py-3 btn-sm" style="width:170px;font-size:1.3rem !important;">{{ lang.save_n_print}}</b-button>
          <b-button type="button" @click="addInvoiceO()" v-else id="addBTN" variant="success" class="ma-2 py-3 btn-sm" style="width:170px;font-size:1.3rem !important;">{{ lang.save_n_print}}</b-button>
          <b-button type="button" v-b-modal.add_addporch id="addModalBTN" variant="success" class="ma-2 py-3 btn-sm" style="display:none;width:170px;font-size:1.3rem !important;">{{ lang.save_n_print}}</b-button>
        </div>

      </template>
    </b-sidebar>
    <invoiceAddApprove ref="approveInvoice" />
    <posAddPurhcase ref="posAddPurhcase" />

        </v-form>
      </div>
</template>

<script>
import axios from 'axios'
import invoiceAddApprove from '@/components/invoiceAddApprove.vue'
import {SnotifyPosition} from 'vue-snotify';
import posAddPurhcase from '@/components/pos-Purchase.vue'
import addCarScetch from '@/components/addCarScetch.vue'

export default{
    components: {invoiceAddApprove,posAddPurhcase,addCarScetch},
    props:[
        'custom','prods','_cardid'
    ],
    data() {
        return {
            activeInvoiceTab: 'customer_car',
            selectedCustomerCar: 0,
            customerCars: [],
            print_type:1,
            cardud: 0,
            contract_id: 0,
            contractOfferedItems: [],
            // True only once THIS auto-detection has itself set contract_id,
            // so checkContractForCar() never clears a contract_id that arrived
            // some other way (e.g. pre-set by CarContractView.vue when this
            // form is opened from inside a contract's own detail screen).
            // Same pattern as addNewCard.vue's contract-pricing feature.
            contractAutoDetected: false,
            quotID: 0,
            crmid: 0,
            allDesc: [],
            allProducts: [],
            images: [],
            counter: 1,
            showModal: false,
            showClientTypeRow: true,
            cardid: 0,
            payby: 1,
            itemSearchTimer: null,
            itemsworkdes:[

            ],
            spareparts:[

            ],
            car: {
                plate_number: '',
                color: '',
                model: '',
                made_year: '',
                workdes: '',
                vin: '',
                engine_meter: '',
                next_oil_change: '',
                brand: '',
            },
            cars: [{
                c1: '',
                c2: '',
                c3: '',
                text: '',
                plate_number: '',
                color: '',
                model: '',
                made_year: '',
                workdes: '',
                vin: '',
                engine_meter: '',
                next_oil_change: '',
                brand: '',
            }],
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            modal: false,
            full_total: 0,
            full_vat: 0,
            full_ftotal: 0,
            showcamp: false,
            showGov: false,
            company:{
                fullname: '',
                vatid: '',
                projectname: '',
                building_no: '',
                street_name: '',
                branch_number: '',
                district: '',
                zipcode: '',
                city:'',
                address:'',
                crt_number: '',
                entity_name: '',
                branch_name: '',
                entity_branch_number: '',
                request_number: '',
                po_number: '',
                po_date: '',
            },
            customer: {
                id:0,
                mobile: '',
                full_name: '',
                customerid: '',
                cctype: 1,
                id_number: '',
                // ctype: [
                //     {
                //         text: lang.individual_client,
                //         value: 1,
                //     },
                //     {
                //         text: lang.company_client,
                //         value: 2,
                //     }
                // ]
            },
            invoice:{
                cost_center: 0,
                consumption_fees: '',
                store_id: 1,
                customer_name: '',
                customer_afforded: '',
                consumption_rate: 2,
                card_type: 1,
                old_invoice: 0,
                carsnumber: 1,
                owner_name: "",
                maint_start_date: '',
                maint_end_date: '',
                policy_number: '',
                date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
                payment:{
                    cash: '',
                    span: ''
                },
                billid: 1,
                discount:'' ,
                t_discount:0 ,
                vtype:2,
                engine_meter: '',
                work_type: 1,
                next_oil_change: '',
                invtype:1,

                paytype: 2,
                paytypes: [

                ],
                userid: 0,
                users: [

                ],
                notes: '',
                insurance: 0,
            },
            fieldRules: [
                // v => !!v || lang.required_field,
            ],
            tbrows:[
            ],
            tbrows1:[
            ],
            newrow:{
                itemcode: '',
                item_type: 1,
                item_name: '',
                qty: 1,
                unitid: 1,
                unitname: "Item",
                item_price: '',
                total: '',
                vat: '',
                ftotal: '',
                plate_number: '',
                extra1: '',
                extra2: '',
                extra3: '',
                type: 'service',
                vat_rate: 15,
                type_of_item: 1
            },
            newrow1:{
                item_type: 2,
                itemcode: '',
                item_name: '',
                qty: 1,
                unitid: 1,
                unitname: "Item",
                item_price: '',
                total: '',
                vat: '',
                ftotal: '',
                plate_number: '',
                extra1: '',
                extra2: '',
                extra3: '',
                type: 'sparepart',
                vat_rate: 15,
                type_of_item: 2
            },
            allRows: [],
            customersList: [],
            calenderTypes: [],
            selectedCar: 0,
            attached: [],
            sd: {
                day: (new Date()).getDate(),
                month: (new Date()).getMonth() + 1,
                year: (new Date()).getFullYear(),
            },
            cd: {
                day: "",
                month: "",
                year: "",
            },
            stores: [],
            newInvoiceId: '',
            unites: [],
            CentersCost: [],
            static_options: {}
        }
    },
    created() {
        this.getInvSettings();
        this.getStaticOptions();
        // setTimeout(() => {
        //     this.getInfo();
        // }, 2000);
        this.getPyamentType();
        // this.invoice.userid
        // this.invoice.userid = this.userinfo.userid
        // // console.log("select",this.$store.state.userinfo);

        this.changeAdduserInfo();
        this.getWorkType()
        this.getCostCenter()
        this.getStores()
    },
    computed:{
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        staticOptions: function () {
            let t = {};
            Object.keys(this.static_options).forEach((key) => {
                t[key] = []; // initialize array for each key

                for (let i = 0; i < this.static_options[key].length; i++) {
                    t[key].push({
                        text: this.static_options[key][i][`name_${this.lang.langname}`],
                        value: this.static_options[key][i].value
                    });
                }
            });

            return t;
        },
        costCenters: function() {
            let t = [{text: '', value: 0}];
            for(let i=0;i< this.CentersCost.length;i++){
                t.push({text: this.CentersCost[i][`name_${this.lang.langname}`], value: this.CentersCost[i].value})
            }
            return t;
        },
        invtypes: function(){
            return [
                    {
                        text: this.lang.none_paid_invoice,
                        value: 2,
                    },
                    {
                        text: this.lang.paid_invoice,
                        value: 1,
                    },
                ]
        },
        carsNums: () => {
            return [
                {text: '1',value: 1},
                {text: '2',value: 2},
                {text: '3',value: 3},
                {text: '4',value: 4},
                {text: '5',value: 5},
                {text: '6',value: 6},
            ]
        },
        customerCarOptions() {
            const placeholder = this.lang.chose_car || this.lang.car_model || 'Choose Car';
            const options = [{ text: placeholder, value: 0 }];

            for (let i = 0; i < this.customerCars.length; i++) {
                const car = this.customerCars[i] || {};
                const parts = [
                    car.plate_number || '',
                    car.brand || '',
                    car.model || '',
                    car.manufacturing_year || car.made_year || ''
                ].filter(Boolean);

                options.push({
                    text: parts.join(' - '),
                    value: car.id || i + 1,
                });
            }

            return options;
        },
        consumptionRate: function(){
            return [
                {text: this.lang.currency_code, value: 1},
                {text: '%', value: 2}
            ];
        },
        storeIds: function() {
            let t = []
            for(let i=0;i<this.stores.length;i++){
                t.push({
                    text: this.stores[i][`name_${ this.lang.langname}`],value: this.stores[i].id
                })
            }
            return t;
        },
        sp: function(){
            let t = {
                total: 0,
                vat: 0,
                ftotal: 0
            }
            // console.log(this.tbrows1);
            for(let i=0;i<this.tbrows1.length;i++){
                t.total = parseFloat(t.total) + parseFloat(this.tbrows1[i].total);
                t.vat = parseFloat(t.vat) + parseFloat(this.tbrows1[i].vat);
                t.ftotal = parseFloat(t.ftotal) + parseFloat(this.tbrows1[i].ftotal);
            }
            // alert(vat)
            return t;
        },
        unitOptions: function(){
            let t = [];
            for(let i=0;i<this.unites.length;i++){
                t.push({
                    text: this.unites[i][`name${ this.lang.langname}`],value: this.unites[i].id
                })
            }
            return t;
        },
        nsp: function(){
            let t = {
                total: 0,
                vat: 0,
                ftotal: 0
            }
            // console.log(this.tbrows1);
            let afforded = this.invoice.customer_afforded
            if(afforded == ''){
                afforded = 0;
            }
            // let inVat = 0;
            let items = [];
            for(let i=0;i<this.tbrows.length;i++){
                console.log(this.tbrows[i])
                let vat_rate = this.tbrows[i].vat_rate;
                if(this.tbrows[i].vat_rate > 1 ) vat_rate = vat_rate / 100;
                if(this.invoice.vtype == 1) vat_rate = 0;
               items.push({price: this.tbrows[i].total, vatRate: vat_rate})
            }
            // console.log("view",[this.invoice.discount,this.invoice.customer_afforded]);
            // let dis = this.invoice.discount;
            // if((this.invoice.discount != 0 && this.invoice.discount != '')){ this.invoice.discount = 0;}
            console.log("this is my res: ", [items, this.invoice.discount])
            const result = this.calculateVATAfterDiscount(items, this.invoice.discount)

            t.total = result.totalAfterDiscountExclVAT.toFixed(2);
            t.vat = result.totalVAT.toFixed(2);
            t.ftotal = result.totalAfterDiscountInclVAT.toFixed(2);

            return t;
        },
        customerLists: function(){

            let t = [{value: 0,text: this.lang.new_customer}];
            for(let i=0;i<this.customersList.length;i++){
                let customername = this.customersList[i].full_name;
                if(this.customer.cctype == 2){
                    customername = this.customersList[i].company_name;
                }
                else if(this.customer.cctype == 3){
                    customername = this.customersList[i].entity_name;
                }
                t.push({
                    text: customername, value: this.customersList[i].id
                })
            }
            return t;
        },
        full_total_in: function(){
            let t = 0;
            t = parseFloat(this.full_ftotal) - parseFloat(this.invoice.insurance);

            return this.$RoundNum(t);
        },
        currentCars: function(){
            let t = [{text: this.lang.chose_car, value: ''}]
            for(let i=0;i<this.cars.length;i++){
                if(this.cars[i].plate_number != '')
                {
                    t.push({
                        text: this.cars[i].plate_number,
                        value: this.cars[i].plate_number,
                    })
                }
            }
            return t;
        },
        ecars: function(){
            let t = []
            for(let i=0;i<this.cars.length;i++){
                t.push(this.cars[i]);
            }
            return t;
        },
        workTypes: function(){
            let t = [];

            for(let i=0;i<this.calenderTypes.length;i++){
                t.push({
                    text: this.calenderTypes[i][`name_${ this.lang.langname}`],value: this.calenderTypes[i].value
                })
            }
            // return [
            //     {text: 'سمكرة ودهان', value: 1},
            //     {text: 'دهان ', value: 2},
            //     {text: 'ميكانيكا وكهرباء', value: 3},
            //     {text: 'ميكانيكا', value: 4},
            //     {text: 'كهرباء', value: 5},
            //     {text: 'شفط وتعديل', value: 6},
            // ]
            return t;
        },
        AcurrentCars: function(){
            let t = [{text: this.lang.chose_car, value: 0}]
            for(let i=0;i<this.cars.length;i++){
                if(this.cars[i].plate_number != '')
                {
                    t.push({
                        text: this.cars[i].plate_number,
                        value: this.cars[i].plate_number,
                    })
                }
            }
            return t;
        },
        vattype: function(){
            if(this.$store.state.settings.vat_number == ''){
                return [
                    {
                        text: this.lang.prices_without_vat,
                        value: 1,
                    },
                ]
            }else{
                return [
                    {
                        text: this.lang.prices_include_vat,
                        value: 3,
                    },
                    {
                        text: this.lang.prices_exclusive_vat,
                        value: 2,
                    },
                    {
                        text: this.lang.prices_without_vat,
                        value: 1,
                    },
                ]
            }

        },
    },
    deactivated() {
        console.log('deactivated', this.cars);
    },
    beforeDestroy() {
        console.log('beforeDestroy', this.cars);
    },
    methods: {
        normalizeCustomerCars(cars) {
            if (!Array.isArray(cars)) {
                return [];
            }

            return cars.map((car) => ({
                id: car.id || car.car_id || 0,
                plate_number: car.plate_number || '',
                vin: car.vin || '',
                color: car.color || '',
                brand: car.brand || '',
                model: car.model || '',
                manufacturing_year: car.manufacturing_year || car.made_year || '',
                made_year: car.made_year || car.manufacturing_year || '',
                engine_meter: car.engine_meter || '',
            }));
        },
        syncCustomerCars(customerRecord = null) {
            let currentCustomer = customerRecord;

            if (!currentCustomer && Array.isArray(this.customersList)) {
                currentCustomer = this.customersList.find((item) => Number(item.id) === Number(this.customer.id || this.customer.customerid || 0));
            }

            this.customerCars = this.normalizeCustomerCars(currentCustomer && currentCustomer.cars_list ? currentCustomer.cars_list : []);

            const selectedExists = this.customerCars.some((car) => Number(car.id) === Number(this.selectedCustomerCar));
            if (!selectedExists) {
                this.selectedCustomerCar = 0;
            }
        },
        applySelectedCustomerCar() {
            const selectedId = Number(this.selectedCustomerCar || 0);
            if (!selectedId) {
                return;
            }

            const selectedCar = this.customerCars.find((car) => Number(car.id) === selectedId);
            if (!selectedCar) {
                return;
            }

            if (!Array.isArray(this.cars) || !this.cars.length) {
                this.cars = [{
                    c1: '',
                    c2: '',
                    c3: '',
                    text: '',
                    plate_number: '',
                    color: '',
                    model: '',
                    made_year: '',
                    workdes: '',
                    vin: '',
                    engine_meter: '',
                    next_oil_change: '',
                    brand: '',
                }];
            }

            const plateParts = [...this.splitPlate(selectedCar.plate_number || ''), '', '', '', ''].slice(0, 4);

            this.$set(this.cars, 0, {
                ...this.cars[0],
                plate_number: selectedCar.plate_number || '',
                vin: selectedCar.vin || '',
                color: selectedCar.color || '',
                brand: selectedCar.brand || '',
                model: selectedCar.model || '',
                made_year: selectedCar.manufacturing_year || selectedCar.made_year || '',
                engine_meter: selectedCar.engine_meter || '',
                c1: plateParts[0] || '',
                c2: plateParts[1] || '',
                c3: plateParts[2] || '',
                text: plateParts[3] || '',
            });

            this.newrow.plate_number = selectedCar.plate_number || '';
            this.newrow1.plate_number = selectedCar.plate_number || '';
            this.checkContractForCar(selectedCar.plate_number || '');
        },
        calculateVATAfterDiscount(items, totalDiscount) {
            // items: array of { price: number, vatRate: number }
            // totalDiscount: number
            if(this.invoice.vtype == 1){
                items.vatRate = 0;
            }
            // const totalPrice = items.reduce((sum, item) => sum + item.price, 0);
            const totalPrice = items.reduce((sum, item) => {
                const priceAsNumber = parseFloat(item.price);

                if (isNaN(priceAsNumber)) {
                    return sum;
                }

                return sum + priceAsNumber;
            }, 0);

            const discountedItems = items.map(item => {
                const discountShare = (item.price / totalPrice) * totalDiscount;
                const discountedPrice = item.price - discountShare;
                const vatAmount = discountedPrice * item.vatRate;
                return {
                originalPrice: item.price,
                discountedPrice,
                vatRate: item.vatRate,
                vatAmount
                };
            });

            const totalAfterDiscountExclVAT = discountedItems.reduce((sum, item) => sum + item.discountedPrice, 0);
            const totalVAT = discountedItems.reduce((sum, item) => sum + item.vatAmount, 0);
            const totalAfterDiscountInclVAT = totalAfterDiscountExclVAT + totalVAT;

            return {
                totalAfterDiscountExclVAT,
                totalVAT,
                totalAfterDiscountInclVAT,
                items: discountedItems
            };
        },
        splitPlate(plate)
        {
            return plate.split(' ');
        },
        getCheckup(id){

            if(id == 0 || id == ''){
                return false;
            }
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","getCurrentCheckup");
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[id]',this.checkUpId);
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                const respo = response.data.results.data;
                if(response.data.results.data.length == 0){
                    return false;
                }
                this.customer.mobile = response.data.results.data[0].mobile;
                this.getAllName(1);
                this.$set(this.cars[0],"plate_numebr", response.data.results.data[0].plate_number);

                //this.getCar(response.data.results.data[0].plate_number,0);
                this.$set(this.cars[0], "plate_number" ,  respo[0].plate_number)
                this.$set(this.cars[0], "engine_meter" ,  respo[0].engine_meter)
                this.$set(this.cars[0], "vin" ,  respo[0].vin)
                this.$set(this.cars[0], "model" ,  respo[0].model)
                this.$set(this.cars[0], "brand" ,  respo[0].brand)
                this.$set(this.cars[0], "color" ,  respo[0].color)
                this.$set(this.cars[0], "made_year" ,  respo[0].made_year)
                const pl = this.splitPlate(response.data.results.data[0].plate_number)

                this.$set(this.cars[0],"c1", pl[0])
                this.$set(this.cars[0],"c2", pl[1])
                this.$set(this.cars[0],"c3", pl[2])
                this.$set(this.cars[0],"text", pl[3])

                this.$set(this.cars[0],"plate","fd",pl[0])
                this.$set(this.cars[0],"plate","sd",pl[1])
                this.$set(this.cars[0],"plate","td",pl[2])
                this.$set(this.cars[0],"plate","num",pl[3])

                this.images[0] = {
                    plate: this.cars[0].plate_number,
                    image: response.data.results.data[0].images
                }

                if(response.data.results.data[0].maints.length > 0){
                    for(let i=0;i<response.data.results.data[0].maints.length;i++){
                        this.tbrows.push({
                            empname: '',
                            itemcode: '',
                            item_name: response.data.results.data[0].maints[i].description,
                            qty: 1,
                            item_price: 0,
                            total: 0,
                            vat: 0,
                            ftotal: 0,
                            plate_number: response.data.results.data[0].plate_number,
                            workers_name: [],
                            brand: '',
                            unitid: 1,
                        })
                    }
                }

                this.company.po_number = response.data.results.data[0].po_number;
            })


        },
        beforeClose() {
            console.log('beforeClose', this.cars);
        },
        makeid(length) {
            let result = '';
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            const charactersLength = characters.length;
            let counter = 0;
            while (counter < length) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
            counter += 1;
            }
            return result;
        },
        getNewInvoiceID(){
            this.newInvoiceID = this.makeid(10)
        },
        getStores(){
            const post = new FormData();
            post.append("type","getStores");
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[id]',-1);
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                this.stores = response.data.results.data;
            });
        },
        plNum(index){
            if(this.cars[index].c1 != '' && this.cars[index].c2  != '' && this.cars[index].c3  !='' && this.cars[index].text){
                this.cars[index].plate_number = this.cars[index].c1 + " " + this.cars[index].c2 + " " + this.cars[index].c3 + " " + this.cars[index].text;
                this.getCar(this.cars[index].plate_number,index)
            }
        },
                // Lazy item lookup. The datalist used to be filled with the whole
        // catalogue on page load; it is now driven by what has been typed,
        // debounced, against the searchItems endpoint. Under 2 characters we
        // clear rather than query -- the result set would be meaningless and
        // the query expensive.
        searchItemsLazy(term){
            const q = String(term || '').trim();
            if(this.itemSearchTimer){
                clearTimeout(this.itemSearchTimer);
            }
            // A picked option arrives as "CODE -||- NAME"; that is a selection,
            // not a search term.
            if(q.length < 2 || q.indexOf(' -||- ') !== -1){
                this.itemsworkdes = [];
                return;
            }
            this.itemSearchTimer = setTimeout(() => {
                const post = new FormData();
                post.append('defBranch', localStorage.getItem('defBranch'));
                post.append('financeYear', localStorage.getItem('financeYear'));
                post.append('type', 'searchItems');
                post.append('auth', this.$cookies.get(this.$store.state.COOKIEPhase));
                post.append('data[q]', q);
                post.append('data[limit]', 20);
                axios.post(this.$store.state.SAMCOTEC.r_path, post).then((response) => {
                    const res = response.data;
                    this.itemsworkdes = (res && res.results && res.results.data) ? res.results.data : [];
                }).catch(() => { this.itemsworkdes = []; });
            }, 250);
        },
        changeMe(){
            const itemn = this.newrow.item_name.split(" -||- ");
            if(itemn.length > 1){
                this.newrow.itemcode = itemn[0];
                this.getProducts();
            }
        },
        toUpper(index){
            this.cars[index].vin=this.cars[index].vin.toUpperCase()
        },
        getItemcode(){
            // console.log(this.allProducts);
            for(let i=0;i<this.allProducts.length;i++){
                if(this.allProducts[i].name == this.newrow1.item_name || this.allProducts[i].nameen == this.newrow1.item_name){
                    this.newrow1.itemcode = this.allProducts[i].itemcode
                }
            }
        },
        save(){
            if(this.$refs.firstCar.image == ''){
                let message = this.lang.plase_select_car_scratch;
                this.$snotify.error(message, this.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                return false;
            }
            if(this.selectedCar == '' || this.selectedCar == 0){
                let message = this.lang.chose_car_before_continue;
                this.$snotify.error(message, this.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                return false;
            }
            let test = false;
            for(let i =0;i < this.images.length;i++){
                if(this.selectedCar == this.images[i].plate){
                    test = true;
                    this.images[i].image = this.$refs.firstCar.image
                }
            }
            if(!test){
                this.images.push({
                    image: this.$refs.firstCar.image,
                    plate: this.selectedCar
                })
            }

            this.$refs.firstCar.$refs.VueCanvasDrawing.reset()
            this.$refs.firstCar.image = '';
            this.selectedCar = 0;
        },
        async getWorkType(){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','getStaticOptions')
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki));
            post.append('data[phrase]','calendarTypes')
            const response = await axios.post(
                this.$store.state.SAMCOTEC.r_path,post
            );
            if(response && response.data){
                this.calenderTypes = response.data.results.data
            }
        },
        async getStaticOptions(){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','getStaticOptions')
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki));
            post.append('data[phrase]','')
            const response = await axios.post(
                this.$store.state.SAMCOTEC.r_path,post
            );
            if(response && response.data){
                this.static_options = response.data.results.res1
            }
        },
        async getCostCenter(){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','getStaticOptions')
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki));
            post.append('data[phrase]','costCenter')
            const response = await axios.post(
                this.$store.state.SAMCOTEC.r_path,post
            );
            if(response && response.data){
                this.CentersCost = response.data.results.data
            }
        },
        updateCarsCount() {
            const n = parseFloat(this.invoice.carsnumber) - parseFloat(this.cars.length)

            if(n > 0) {
                for(let i = parseFloat(this.cars.length) - 1;i< (parseFloat(this.invoice.carsnumber) - parseFloat(1));i++){
                    // this.cars.push(this.car)
                    this.cars.push({
                        plate_number:  this.car.plate_number,
                        color:  this.car.color,
                        model:  this.car.model,
                        made_year:  this.car.made_year,
                        workdes:  this.car.workdes,
                        vin: this.car.vin,
                        engine_meter: this.car.engine_meter,
                        next_oil_change: this.car.next_oil_change,
                        brand: this.car.brand,
                    })
                }
            }else if(n < 0){
                // let d = parseFloat(this.cars.length) - parseFloat(this.invoice.carsnumber);
                // let i = 0;
                let ca = [];
                for(let i=0;i<this.cars.length;i++){
                    // alert([i,this.invoice.carsnumber]);
                    if(i < parseFloat(this.invoice.carsnumber)){
                        ca.push(this.cars[i])
                    }
                }
                this.cars = ca;
                // while (d != 0){
                //     // console.log(d,this.cars[i]);
                //     if(typeof this.cars[i] !== 'undefined'){
                //         if(this.cars[i].plate_number == ''){
                //             alert(i);
                //             this.cars.splice(i,1);
                //             d = d - 1;
                //         }
                //     }else{
                //         d = d - 1;
                //     }

                //     i++;
                // }
                // if(d != 0){
                //     for(let i = this.cars.length - 1 ;i> d;i--){
                //         alert(d);
                //         this.cars.splice(i,1);
                //     }
                // }
            }
        },
        getVatType(){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","getProducts");
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki));
            post.append('data[item_number]',this.newrow1.itemcode);
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
//
            })
        },
        selectCustomer(){
            let matchedCustomer = null;
            for(let i=0;i<this.customersList.length;i++){
                if(this.customer.cctype == 1 && this.customersList[i].id == this.customer.id){
                    matchedCustomer = this.customersList[i];
                    this.customer.customerid = this.customersList[i].id;
                    this.customer.full_name = this.customersList[i].full_name
                    this.company.full_name = ''
                    this.company.entity_name = '';
                    this.company.branch_name = '';

                    this.company.fullname = '';
                    this.company.address = '';
                    this.company.building_no = '';
                    this.company.city = '';
                    this.company.company_vatid = '';
                    this.company.crt_number = '';
                    this.company.district = '';
                    this.company.branch_number = '';
                    this.company.street_name = '';
                    this.company.zipcode = '';
                }
                else if(this.customer.cctype == 2 && this.customersList[i].id == this.customer.id){
                    matchedCustomer = this.customersList[i];
                    this.customer.customerid = this.customersList[i].customerid;
                    this.company.fullname = this.customersList[i].company_name;
                    this.company.address = this.customersList[i].address;
                    this.company.building_no = this.customersList[i].building_no;
                    this.company.city = this.customersList[i].city;
                    this.company.company_vatid = this.customersList[i].company_vatid;
                    this.company.crt_number = this.customersList[i].crt_number;
                    this.company.district = this.customersList[i].district;
                    this.company.branch_number = this.customersList[i].branch_number;
                    this.company.street_name = this.customersList[i].street_name;
                    this.company.zipcode = this.customersList[i].zipcode;
                }
                else if(this.customer.cctype == 3 && this.customersList[i].id == this.customer.id){
                    matchedCustomer = this.customersList[i];

                    this.company.customerid = this.customersList[i].id;
                    this.company.entity_name = this.customersList[i].entity_name;
                    this.company.branch_name = this.customersList[i].branch_name;

                    this.company.fullname = '';
                    this.company.address = '';
                    this.company.building_no = '';
                    this.company.city = '';
                    this.company.company_vatid = '';
                    this.company.crt_number = '';
                    this.company.district = '';
                    this.company.branch_number = '';
                    this.company.street_name = '';
                    this.company.zipcode = '';
                }
                if(this.customer.id == 0 || this.customersList[i].customer_type != this.customer.cctype){

                    this.customer.customerid = 0;
                    this.customer.id = 0
                    this.company.full_name = ''
                    this.company.entity_name = '';
                    this.company.branch_name = '';

                    this.company.fullname = '';
                    this.company.address = '';
                    this.company.building_no = '';
                    this.company.city = '';
                    this.company.company_vatid = '';
                    this.company.crt_number = '';
                    this.company.district = '';
                    this.company.branch_number = '';
                    this.company.street_name = '';
                    this.company.zipcode = '';
                }
            }
            this.syncCustomerCars(matchedCustomer);
        },
        convertToComa(num){
            // // console.log(this.$store.state.licenseType.moneyComma);
            if(this.$store.state.licenseType.moneyComma){
                return Number(num).toLocaleString()
            }else{
                return num
            }
        },
        addInvoicex(){
            this.invoice.date = `${this.sd.year}-${('0'+this.sd.month).slice(-2)}-${('0'+this.sd.day).slice(-2)}`;
            const date = new Date(this.invoice.date).getTime();
            const cdate = new Date().getTime();
            if(cdate < date){
                let message = this.lang.date_out_of_day;
                this.invoice.date = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10)
                this.$snotify.error(message, this.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                // return false;
            }
            this.allRows = [];
            for(let i=0;i<this.tbrows.length;i++){
                this.allRows.push(this.tbrows[i]);
            }
            for(let j=0;j<this.tbrows1.length;j++){
                this.allRows.push(this.tbrows1[j]);
            }
            for(let j=0;j<this.allRows.length;j++){
                if(this.allRows[j].item_price == ''){
                    let message = this.lang.item_price_empty_warning;
                    this.invoice.date = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10)
                    this.$snotify.error(message, this.lang.alert, {
                        timeout: 1000000,
                        showProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        position: SnotifyPosition.centerCenter,
                        buttons: [
                            {
                                text: this.lang.close,
                                action: (toast) => {
                                    this.$snotify.remove(toast.id);
                                }
                            },
                        ]
                    });
                    return false;
                }
            }

            if(this.counter == 1){
                //
            }
            // if(this.$store.state.licenseType.directInvoice){
            //     this.addInvoice();
            //     return false;
            // }

            if (this.$snotify.notifications.length > 0) {
                this.$snotify.notifications.forEach(notification => {
                    this.$snotify.remove(notification.id)
                });
            }
            if(!this.$refs.forinv.validate()){
                return false;
            }
            // if(this.customer.mobile == '') {
            //     this.customer.mobile = 1234567890;
            // }
            const mobilexx = this.customer.mobile.split("");
            if(mobilexx.length < 10 || mobilexx[0] != 0 || mobilexx[1] != 5){
                let message = this.lang.mobile_format_invalid;
                this.$snotify.error(message, this.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                return false;
            }
            if(this.customer.full_name == '') {
                this.customer.full_name = this.lang.individual_client;
            }
            // // console.log("asdfasf",this.tbrows.length);
            // // console.log([this.full_ftotal,this.invoice.payment.cash]);
            let x = 1;
            const cash = parseFloat(this.full_ftotal) + parseFloat(this.sp.ftotal)
            if(this.invoice.payment.cash > cash){
                let message = this.lang.pay_more_than_price;
                this.$snotify.error(message, this.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                this.invoice.payment.cash = this.full_ftotal
                if(this.invoice.payment.cash == 0) this.invoice.payment.cash = '';
                return false;
            }
            if(this.tbrows.length == 0 && this.tbrows1.length == 0){
                let message = this.lang.you_can_not_add_empty_invoice;
                this.$snotify.error(message, this.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                return false;
            }
            // building_no: '',
            // street_name: '',
            // branch_number: '',
            // district: '',
            // zipcode: '',
            // city:'',
            // address:'',
            // crt_number: ''
           let address = true;
           if(this.company.address == ''){
                if(
                    this.company.building_no == '' && this.company.street_name == '' &&
                    this.company.branch_number == '' && this.company.district == '' &&
                    this.company.zipcode == '' && this.company.city == ''
                ){
                    address = false;
                }
           }
        //    if(this.customer.cctype == 2 && (this.company.fullname == '' || !address || this.company.crt_number == '')){
           if(this.customer.cctype == 2 && (this.company.fullname == '' || !address)){
               let message = this.lang.company_ifnormation_required;
                this.$snotify.error(message, this.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                return false;
           }else if(this.customer.cctype == 2 && this.company.fullname != '' && address){
                this.customer.fullname = this.company.fullname;
                this.customer.full_name = this.company.fullname;
           }
           if(this.customer.cctype == 3 && this.company.entity_name == ''){
            let message = this.lang.company_ifnormation_required;
                this.$snotify.error(message, this.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                return false;
           }else if(this.customer.cctype == 3 && this.company.entity_name != ''){
                this.customer.fullname = this.company.entity_name;
                this.customer.full_name = this.company.entity_name;
           }
           if(this.$store.state.licenseType.carInfoRequired){
            for(let i=0;i<this.cars.length;i++){
                if(this.cars[i].plate_number == '' || this.cars[i].model == '' || this.cars[i].made_year == ''){
                    let message = this.lang.car_ifnormation_required;
                    this.$snotify.error(message, this.lang.alert, {
                        timeout: 1000000,
                        showProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        position: SnotifyPosition.centerCenter,
                        buttons: [
                            {
                                text: this.lang.close,
                                action: (toast) => {
                                    this.$snotify.remove(toast.id);
                                }
                            },
                        ]
                    });
                    // return false;
                }
            }
           }
           this.invoice.payment.cash = parseFloat(this.invoice.payment.cash) + parseFloat(this.sp.ftotal)
            this.$refs.approveInvoice.modifyIt({
                total: parseFloat(this.nsp.total) + parseFloat(this.sp.total),
                vat: parseFloat(this.nsp.vat) + parseFloat(this.sp.vat),
                ftotal: parseFloat(this.nsp.ftotal) + parseFloat(this.sp.ftotal),
                paid: this.invoice.payment.cash,
                work_type: this.invoice.work_type,
                trow: this.allRows
            })
        },
        hide(){
            this.reset();
        },
        reset1(){
            // alert(this.cars[0].brand)
            this.images = []
            this.tbrows = [];
            this.tbrows1 = [];
            this.carsnumber = 1;
            this.cars = [];
            this.cars = [{
                c1: '',
                c2: '',
                c3: '',
                text: '',
                plate_number: '',
                color: '',
                model: '',
                made_year: '',
                workdes: '',
                vin: '',
                engine_meter: '',
                next_oil_change: '',
                brand: '',
            }]
            this.getCar('', 0);
            this.company = {
                fullname: '',
                vatid: '',
                projectname: '',
                building_no: '',
                street_name: '',
                branch_number: '',
                district: '',
                zipcode: '',
                city:'',
                address:'',
                crt_number: '',
                entity_name: '',
                branch_name: '',
                entity_branch_number: '',
                request_number: '',
                po_number: '',
                po_date: '',
            }
            this.customer.id = 0;
            this.customer.mobile = '';
            this.customer.full_name = '';
            this.customer.customerid = '';
            this.customer.cctype = 1;
            this.customer.customer_type = 1;

            this.invoice.date = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
            this.invoice.billid = 1
            this.invoice.discount = ''
            this.invoice.t_discount = 0
            this.invoice.engine_meter = ''
            this.invoice.next_oil_change = ''
            this.invoice.notes = ''
            this.invoice.customer_name = ''
            this.invoice.customer_afforded = ''
            this.invoice.consumption_fees = ''
            this.invoice.consumption_rate = 2
            this.invoice.insurance = ''
            this.invoice.cost_center = 0;
            this.invoice.contact_person = '';
            this.invoice.contact_person_mobile = '';
            this.invoice.who_will_contact = 1;
            this.newrow.itemcode = '';
            this.newrow.item_name = '';
            this.newrow.qty = 1;
            this.newrow.newrow = 1;
            this.newrow.item_type = 2;
            this.newrow.type_of_item = 1;
            this.resetInvoicex();
        },
        reset(){
            // alert(this.cars[0].brand)
            this.images = []
            this.tbrows = [];
            this.tbrows1 = [];
            this.carsnumber = 1;
            this.cars = [];
            this.cars = [{
                c1: '',
                c2: '',
                c3: '',
                text: '',
                plate_number: '',
                color: '',
                model: '',
                made_year: '',
                workdes: '',
                vin: '',
                engine_meter: '',
                next_oil_change: '',
                brand: '',
            }]
            this.getCar('', 0);
            this.company = {
                fullname: '',
                vatid: '',
                projectname: '',
                building_no: '',
                street_name: '',
                branch_number: '',
                district: '',
                zipcode: '',
                city:'',
                address:'',
                crt_number: '',
                entity_name: '',
                branch_name: '',
                entity_branch_number: '',
                request_number: '',
                po_number: '',
                po_date: '',
            }
            this.customer.id = 0;
            this.customer.mobile = '';
            this.customer.full_name = '';
            this.customer.customerid = '';
            this.customer.cctype = 1;
            this.customer.customer_type = 1;

            this.invoice.date = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
            this.invoice.billid = 1
            this.invoice.discount = ''
            this.invoice.t_discount = 0
            this.invoice.engine_meter = ''
            this.invoice.next_oil_change = ''
            this.invoice.notes = ''
            this.invoice.customer_name = ''
            this.invoice.customer_afforded = ''
            this.invoice.consumption_fees = ''
            this.invoice.consumption_rate = 2
            this.invoice.insurance = ''
            this.invoice.cost_center = 0
            this.invoice.maint_start_date = ''
            this.invoice.maint_end_date = ''
            this.invoice.policy_number = ''
            this.newrow.itemcode = '';
            this.newrow.item_name = '';
            this.newrow.item_name = '';
            this.newrow.item_type = 2;
            this.invoice.contact_person = '';
            this.invoice.contact_person_mobile = '';
            this.invoice.who_will_contact = 1;
            this.newrow.qty = 1;
            this.newrow.newrow = 1;
            this.newrow.type_of_item = 1;
            this.resetInvoice();
        },
        resetCont(){
            // alert(this.cars[0].brand)
            this.contract_id = 0;
            this.contractOfferedItems = [];
            this.contractAutoDetected = false;
            this.images = []
            this.tbrows = [];
            this.tbrows1 = [];
            this.carsnumber = 1;
            this.cars = [];
            this.cars = [{
                c1: '',
                c2: '',
                c3: '',
                text: '',
                plate_number: '',
                color: '',
                model: '',
                made_year: '',
                workdes: '',
                vin: '',
                engine_meter: '',
                next_oil_change: '',
                brand: '',
            }]
            this.getCar('', 0);
            this.company = {
                fullname: '',
                vatid: '',
                projectname: '',
                building_no: '',
                street_name: '',
                branch_number: '',
                district: '',
                zipcode: '',
                city:'',
                address:'',
                crt_number: '',
                entity_name: '',
                branch_name: '',
                entity_branch_number: '',
                request_number: '',
                po_number: '',
                po_date: '',
            }
            this.customer.id = 0;
            this.customer.mobile = '';
            this.customer.full_name = '';
            this.customer.customerid = '';
            this.customer.cctype = 1;
            this.customer.customer_type = 1;

            this.invoice.date = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
            this.invoice.billid = 1
            this.invoice.discount = ''
            this.invoice.t_discount = 0
            this.invoice.engine_meter = ''
            this.invoice.next_oil_change = ''
            this.invoice.notes = ''
            this.invoice.customer_name = ''
            this.invoice.customer_afforded = ''
            this.invoice.consumption_fees = ''
            this.invoice.consumption_rate = 2
            this.invoice.insurance = ''
            this.newrow.itemcode = '';
            this.newrow.item_name = '';
            this.newrow.item_type = 2;
            this.newrow.qty = 1;
            this.newrow.newrow = 1;
            this.newrow.type_of_item = 1;
            this.invoice.contact_person = '';
            this.invoice.contact_person_mobile = '';
            this.invoice.who_will_contact = 1;
        },
        updateCars(car){
            let cars = this.cars;
            for(let i=0;i<cars.length;i++){
                if(cars[i].plate_numebr == car.plate_numebr){
                    cars[i] = car;
                }
            }
            this.cars = cars;
        },
        postNewRow(){
            for(let i=0;i<this.currentCars.length;i++){
                this.newrow.plate_number=this.newrow[i].plate_number;
            }
        },
        deleteCar(index){
            this.cars.splice(index,1);
        },
        addNewCar(){
            this.cars.push({
                plate_number: '',
                color: '',
                model: '',
                made_year: '',
                workdes: '',
                vin: '',
                engine_meter: '',
                next_oil_change: '',
                brand: ''
            });
        },
        changeCusType(id){
            const selectedType = parseInt(id, 10);
            const activeType = Number.isNaN(selectedType) ? 0 : selectedType;
            const setClass = (elementId, className, enabled) => {
                const element = document.getElementById(elementId);
                if(!element) return;
                if(enabled) element.classList.add(className);
                else element.classList.remove(className);
            };

            this.customer.cctype = activeType + 1;
            this.showcamp = activeType == 1;
            this.showGov = activeType == 2;

            setClass('_indiv', 'hideme', activeType != 0);
            setClass('_comps', 'hideme', activeType != 1);
            setClass('_goves', 'hideme', activeType != 2);

            setClass('_cInd', 'redColor', activeType == 0);
            setClass('_cCom', 'redColor', activeType == 1);
            setClass('_cGov', 'redColor', activeType == 2);
            setClass('_cInd', 'weightColor', activeType != 0);
            setClass('_cCom', 'weightColor', activeType != 1);
            setClass('_cGov', 'weightColor', activeType != 2);

            this.customersList = [];
            this.customerCars = [];
            this.selectedCustomerCar = 0;
            this.getAllName();
            // this.changeCtype();
        },
        changeAdduserInfo(){
            const cook = this.$cookies.get(this.$store.state.COOKIEPhase).split('||');
            this.invoice.userid = cook[0]
        },

        getProducts() {
            // if(this.newrow1.itemcode == ''){
            //     return false;
            // }
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","getProducts");
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki));
            post.append('data[item_number]',this.newrow1.itemcode == '' ? this.newrow.itemcode : this.newrow1.itemcode);
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                if(response.data.results.data.length > 0){
                    if((this.$store.state.licenseType.require_itemcode || this.$store.state.licenseType.requirePurchase)) {
                        let goOn = true;
                        for(let i = 0; i < response.data.results.data[0].qtty.length; i++){

                            if(response.data.results.data[0].qtty[i].qtty > 0) {
                                goOn = false;
                            }
                        }
                        if(goOn) {
                            this.newrow.itemcode = '';
                            this.newrow.description = '';
                            this.newrow.qty = '';
                            this.newrow.price = '';
                            this.newrow.total = '';
                            let message = this.lang.error_no_qty;
                            this.$snotify.error(message, this.lang.alert, {
                                timeout: 1000000,
                                showProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                position: SnotifyPosition.centerCenter,
                                buttons: [
                                    {
                                        text: this.lang.cancel,
                                        action: (toast) => {
                                            this.$snotify.remove(toast.id);
                                            // document.getElementById('addModalBTN').click()
                                        }
                                    },

                                ]
                            });
                            return false;
                        }
                    }
                    //  && (!this.$store.state.licenseType.require_itemcode || !this.$store.state.licenseType.requirePurchase)
                    this.newrow.itemcode = response.data.results.data[0].item_code;
                    this.newrow.item_name = response.data.results.data[0][`item_name${ this.lang.langname}`];
                    this.newrow.item_price = response.data.results.data[0].default_price;
                    this.newrow.vat_rate = response.data.results.data[0].vat_rate;
                    this.newrow.item_type = response.data.results.data[0].item_type;
                    this.newrow.qty = 1;
                    this.newrow.type_of_item = 1;
                    // this.calcKit();
                    this.calcKit();
                    document.getElementById('newitemqty').focus();

                }else{
                    if((this.$store.state.licenseType.require_itemcode || this.$store.state.licenseType.requirePurchase)) {
                        this.newrow.itemcode = '';
                        this.newrow.description = '';
                        this.newrow.qty = '';
                        this.newrow.price = '';
                        this.newrow.total = '';
                        this.newrow.type_of_item = 1;
                        let message = this.lang.error_no_qty;
                        this.$snotify.error(message, this.lang.alert, {
                            timeout: 1000000,
                            showProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            position: SnotifyPosition.centerCenter,
                            buttons: [
                                {
                                    text: this.lang.cancel,
                                    action: (toast) => {
                                        this.$snotify.remove(toast.id);
                                        // document.getElementById('addModalBTN').click()
                                    }
                                },

                            ]
                        });
                        return false;
                    }
                }
                this.calcKit();
                this.calcKit1();
            })
        },
        getItemname(){
            // if(this.newrow.itemcode == ''){
            //     return false;
            // }
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type" , "getItemBycode");
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[itemcode]',this.newrow.itemcode)
            axios.post(
                this.$store.state.SAMCOTEC.r_path , post
            ).then((response) => {
                const res = response.data.results.data.results;
                if(res.length != 0){
                    this.newrow.item_name = res[0].name;
                    this.newrow.item_price = res[0].price;
                    this.newrow.vat_rate = res[0].vat_rate ?? 15;
                    this.newrow.type_of_item = 1;
                }
                this.calcKit();
                this.calcKit1();
                document.getElementById('newitemqty').focus();
            })
        },
        getInfo(){
            if(this.custom == null) {return false;}
            this.customer.mobile = this.custom.mobile;
            this.company.fullname = this.custom.company;
            this.company.vatid = this.custom.vatid;
            this.getName();
        },
        resetInvoice(){
            this.payby = 1;
            this.car = {
                c1: '',
                c2: '',
                c3: '',
                text: '',
                plate_number: '',
                color: '',
                model: '',
                made_year: '',
                workdes: '',
                vin: '',
                engine_meter: '',
                next_oil_change: '',
                brand: '',
            };
            this.cars = [];

            this.getCar('', 0)
            this.cars[0]['model'] = '';
            this.cars[0]['color'] = '';
            this.cars[0]['plate_number'] = '';
            this.cars[0]['made_year'] = '';
            this.cars[0]['brand'] = '';
            this.modal = false;
            this.full_total =  0;
            this.full_vat =  0;
            this.full_ftotal =  0;
            this.showcamp =  false;
            this.company = {
                fullname: '',
                vatid: '',
                projectname: '',
                building_no: '',
                street_name: '',
                branch_number: '',
                district: '',
                zipcode: '',
                city:'',
                address:'',
                crt_number: '',
                entity_name: '',
                branch_name: '',
                entity_branch_number: '',
                request_number: '',
                po_number: '',
                po_date: '',
            };
            this.customer.id = 0;
            this.customer.mobile = '';
            this.customer.full_name = '';
            this.customer.customerid = '';
            this.customer.cctype = 1;
            this.customer.customer_type = 1;
            this.customer.id_number = "";
            this.invoice.payment.cash = '';
            this.invoice.payment.span = '';
            this.invoice.payment.discount = '';
            this.invoice.payment.vtype = 0;
            this.invoice.payment.t_discount = 0;
            this.invoice.contact_person = '';
            this.invoice.contact_person_mobile = '';
            this.invoice.who_will_contact = 1;
            this.invoice.owner_name = 0;
            this.invoice.maint_start_date = '';
            this.invoice.maint_end_date = '';
            this.invoice.policy_number = '';
            this.changeCusType(0)
            this.tbrows = [
            ];
            this.newrow = {
                plate_number: this.newrow.plate_numebr,
                itemcode: '',
                item_type: 1,
                item_name: '',
                qty: 1,
                unitid: 1,
                unitname: 'Item',
                item_price: '',
                total: '',
                vat: '',
                ftotal: '',
                extra1: '',
                extra2: '',
                extra3: '',
                type: 'service',
                type_of_item: this.newrow.type_of_item ?? 1,
                vat_rate: this.$store.state.settings.def_vat
            }
        },
        resetInvoicex(){
            this.payby = 1;
            this.car = {
                c1: '',
                c2: '',
                c3: '',
                text: '',
                plate_number: '',
                color: '',
                model: '',
                made_year: '',
                workdes: '',
                vin: '',
                engine_meter: '',
                next_oil_change: '',
                brand: '',
            };
            this.cars = [];

            this.getCar('', 0)
            this.cars[0]['model'] = '';
            this.cars[0]['color'] = '';
            this.cars[0]['plate_number'] = '';
            this.cars[0]['made_year'] = '';
            this.cars[0]['brand'] = '';
            this.modal = false;
            this.full_total =  0;
            this.full_vat =  0;
            this.full_ftotal =  0;
            this.showcamp =  false;
            this.company = {
                fullname: '',
                vatid: '',
                projectname: '',
                building_no: '',
                street_name: '',
                branch_number: '',
                district: '',
                zipcode: '',
                city:'',
                address:'',
                crt_number: '',
                entity_name: '',
                branch_name: '',
                entity_branch_number: '',
                request_number: '',
                po_number: '',
                po_date: '',
            };
            this.customer.id = 0;
            this.customer.mobile = '';
            this.customer.full_name = '';
            this.customer.customerid = '';
            this.customer.cctype = 1;
            this.customer.customer_type = 1;
            this.customer.id_number = "";
            this.invoice.payment.cash = '';
            this.invoice.payment.span = '';
            this.invoice.payment.discount = '';
            this.invoice.payment.vtype = 0;
            this.invoice.payment.t_discount = 0;
            this.invoice.owner_name = 0;
            this.invoice.contact_person = '';
            this.invoice.contact_person_mobile = '';
            this.invoice.who_will_contact = 1;

            this.tbrows = [
            ];
            this.newrow = {
                plate_number: this.newrow.plate_numebr,
                itemcode: '',
                item_type: 2,
                item_name: '',
                qty: 1,
                unitid: 1,
                unitname: 'Item',
                item_price: '',
                total: '',
                vat: '',
                ftotal: '',
                extra1: '',
                extra2: '',
                extra3: '',
                type: 'service',
                type_of_item: this.newrow.type_of_item ?? 1,
                vat_rate: this.$store.state.settings.def_vat
            }
        },
        addInvoiceO(){
            let message = this.lang.locking_invoice_warning;
            this.$snotify.error(message, this.lang.alert, {
                timeout: 1000000,
                showProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                position: SnotifyPosition.centerCenter,
                buttons: [
                    {
                        text: this.lang.review_invoice,
                        class: 'backBlue',
                        action: (toast) => {
                            this.$snotify.remove(toast.id);
                        }
                    },
                    {
                        text: this.lang.cancel_invoice,
                        class: 'backRed',
                        action: (toast) => {
                            this.$snotify.remove(toast.id);
                            document.getElementById('HideInvoice').click();
                        }
                    },
                    {
                        text: this.lang.issue_invoice,
                        class: 'backGreen',
                        action: (toast) => {
                            this.$snotify.remove(toast.id);
                            this.addInvoice();
                        }
                    },
                ]
            });
            return false;
        },
        addInvoicexO(){
            let message = this.lang.locking_invoice_warning;
            this.$snotify.error(message, this.lang.alert, {
                timeout: 1000000,
                showProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                position: SnotifyPosition.centerCenter,
                buttons: [
                    {
                        text: this.lang.review_invoice,
                        action: (toast) => {
                            this.$snotify.remove(toast.id);
                        }
                    },
                    {
                        text: this.lang.cancel_invoice,
                        action: (toast) => {
                            this.$snotify.remove(toast.id);
                        }
                    },
                    {
                        text: this.lang.issue_invoice,
                        action: (toast) => {
                            this.$snotify.remove(toast.id);
                            this.addInvoice();
                        }
                    },
                ]
            });
            return false;
        },
        addInvoice(){
            this.invoice.date = `${this.sd.year}-${('0'+this.sd.month).slice(-2)}-${('0'+this.sd.day).slice(-2)}`;
            if(this.cd.year != '' && this.cd.month != '' && this.cd.day != ''){
                this.company.po_date = `${this.cd.year}-${('0'+this.cd.month).slice(-2)}-${('0'+this.cd.day).slice(-2)}`;
            }
            if (this.$snotify.notifications.length > 0) {
                this.$snotify.notifications.forEach(notification => {
                    this.$snotify.remove(notification.id)
                });
            }
            if(!this.$refs.forinv.validate()){
                return false;
            }

            // // console.log("asdfasf",this.tbrows.length);
            // // console.log([this.full_ftotal,this.invoice.payment.cash]);
            let x = 1;
            const cash = parseFloat(this.full_ftotal) + parseFloat(this.sp.ftotal)
            for(let i =0;i<this.cars.length;i++){
                if(this.cars[i].c1 != '' && this.cars[i].c2 != '' && this.cars[i].c3 != '' && this.cars[i].text != ''){
                    this.cars[i].plate_number = this.cars[i].c1 + " " + this.cars[i].c2 + " " + this.cars[i].c3 + " " + this.cars[i].text;
                }
            }
            if(this.invoice.payment.cash > cash){
                let message = this.lang.pay_more_than_invoiced;
                this.$snotify.error(message, this.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                this.invoice.payment.cash = this.full_ftotal
                if(this.invoice.payment.cash == 0) this.invoice.payment.cash = '';
                return false;
            }
            for(let i = 0; i < this.tbrows.length;i++){
                // console.log(this.tbrows);
                if(this.tbrows[i].item_price == ''){
                    let message = this.lang.price_empty_warning;
                    this.$snotify.error(message, this.lang.alert, {
                        timeout: 1000000,
                        showProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        position: SnotifyPosition.centerCenter,
                        buttons: [
                            {
                                text: this.lang.close,
                                action: (toast) => {
                                    this.$snotify.remove(toast.id);
                                }
                            },
                        ]
                    });
                    this.invoice.payment.cash = this.full_ftotal
                    if(this.invoice.payment.cash == 0) this.invoice.payment.cash = '';
                    return false;
                }
            }
            for(let i = 0; i < this.tbrows1.length;i++){
                // console.log(this.tbrows1);
                if(this.tbrows1[i].item_price == ''){
                    let message = this.lang.price_empty_warning;
                    this.$snotify.error(message, this.lang.alert, {
                        timeout: 1000000,
                        showProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        position: SnotifyPosition.centerCenter,
                        buttons: [
                            {
                                text: this.lang.close,
                                action: (toast) => {
                                    this.$snotify.remove(toast.id);
                                }
                            },
                        ]
                    });
                    this.invoice.payment.cash = this.full_ftotal
                    if(this.invoice.payment.cash == 0) this.invoice.payment.cash = '';
                    return false;
                }
            }
            if(this.tbrows.length == 0 && this.tbrows1.length == 0){
                let message = this.lang.you_can_not_add_empty_invoice;
                this.$snotify.error(message, this.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                return false;
            }

           let address = true;
           if(this.company.address == ''){
                if(
                    this.company.building_no == '' && this.company.street_name == '' &&
                    this.company.branch_number == '' && this.company.district == '' &&
                    this.company.zipcode == '' && this.company.city == ''
                ){
                    address = false;
                }
           }

           if(this.customer.cctype == 2 && (this.company.fullname == '' || !address)){
               let message = this.lang.company_ifnormation_required;
                this.$snotify.error(message, this.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                return false;
           }else if(this.customer.cctype == 2 && this.company.fullname != '' && address){
                this.customer.fullname = this.company.fullname;
                this.customer.full_name = this.company.fullname;
           }
           if(this.customer.cctype == 3 && this.company.entity_name == ''){
            let message = this.lang.company_ifnormation_required;
                this.$snotify.error(message, this.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                return false;
           }else if(this.customer.cctype == 3 && this.company.entity_name != ''){
                this.customer.fullname = this.company.entity_name;
                this.customer.full_name = this.company.entity_name;
           }
           if(this.$store.state.licenseType.carInfoRequired){
             for(let i=0;i<this.cars.length;i++){
                if(this.cars[i].text == "" || this.cars[i].c1 == '' ||
                    this.cars[i].c2 == '' || this.cars[i].c2 == ''
                ){
                    this.cars[i].plate_number = '';
                }
                if(this.cars[i].plate_number == '' || this.cars[i].model == '' || this.cars[i].made_year == ''){
                    let message = this.lang.car_ifnormation_required;
                    this.$snotify.error(message, this.lang.alert, {
                        timeout: 1000000,
                        showProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        position: SnotifyPosition.centerCenter,
                        buttons: [
                            {
                                text: this.lang.close,
                                action: (toast) => {
                                    this.$snotify.remove(toast.id);
                                }
                            },
                        ]
                    });
                    return false;
                }
             }
           }
            document.getElementById('addBTN').disabled = true;
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type" , "addInvoice");
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[customer]',JSON.stringify(this.customer))
            // for(const [key, value] of Object.entries(this.customer)){
            //     post.append('data[customer]['+key+']]',value);
            // }
            // // console.log(this.company);
            post.append('data[company]',JSON.stringify(this.company))
            // for(const [key, value] of Object.entries(this.company)){
            //     post.append('data[company]['+key+']]',value);
            // }
            post.append('data[images]',JSON.stringify(this.images))
            // for(let i=0;i<this.images.length;i++){
            //     post.append('data[images]['+i+'][image]',this.images[i].image)
            //     post.append('data[images]['+i+'][plate]',this.images[i].plate)
            // }
            this.fillTbrowsItemCodes();
            let rows = [];
            for(let i = 0; i < this.tbrows.length;i++){
                rows.push(this.tbrows[i])
            }
            for(let i = 0; i < this.tbrows1.length;i++){
                rows.push(this.tbrows1[i])
            }
            post.append('data[tbrows]',JSON.stringify(rows));
            // for(let i = 0; i < rows.length;i++){
            //     for(const [key, value] of Object.entries(rows[i])){
            //         post.append('data[tbrows]['+i+']['+key+']]',value);
            //     }
            // }
            // for(let i = 0; i < this.tbrows1.length;i++){
            //     for(const [key, value] of Object.entries(this.tbrows1[i])){
            //         post.append('data[tbrows]['+i+']['+key+']]',value);
            //     }
            // }
            post.append('data[cars]',JSON.stringify(this.cars));

            // for(let i = 0; i < this.cars.length;i++){
            //     for(const [key, value] of Object.entries(this.cars[i])){
            //         post.append('data[cars]['+i+']['+key+']]',value);
            //     }
            // }
            // for(const [key, value] of Object.entries(this.car)){
            //     post.append('data[car]['+key+']]',value);
            // }
            // for(let i = 0; i < this.inovice.length;i++){
            //     for(const [key, value] of Object.entries(this.inovice[i])){
            //         post.append('data[inovice]['+i+']['+key+']]',value);
            //     }
            // }
            if(this.invoice.invtype == 1){
                this.invoice.payment.cash = parseFloat(this.nsp.ftotal) + parseFloat(this.sp.ftotal);
            }

            this.invoice.full_total = parseFloat(this.nsp.total) + parseFloat(this.sp.total);
            this.invoice.full_vat = parseFloat(this.nsp.vat) + parseFloat(this.sp.vat);
            this.invoice.full_ftotal = parseFloat(this.nsp.ftotal) + parseFloat(this.sp.ftotal);
            this.invoice.t_discount = this.invoice.discount == '' ? 0 : this.invoice.discount;
            this.invoice.old_invoice = this.company.old_invoice;
            this.invoice.projectname = this.company.projectname;

            post.append('data[inovice]',JSON.stringify(this.invoice));
            post.append("data[contract_id]",this.contract_id);
            post.append("data[newInvoiceID]",this.newInvoiceID);
            post.append("data[cardid]",this.cardid);
            // alert(this.$SAMCOTEC.r_path);
            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then((resposne) => {

                const body = resposne.data || {};
                const result = body.results || {};
                const saved = body.error && body.error.number == 200
                    && result.data && result.data.results && result.data.results.newID > 0
                    && Array.isArray(result.DASF) && result.DASF.length > 0
                    && result.DASF.every(row => row.error && row.error.number == 200)
                    && !(result.err && result.err.message);
                if (!saved && !(body.error && body.error.number == 210)) {
                    const failure = new Error('invoice_save_failed');
                    failure.response = {data: body};
                    throw failure;
                }
                if(resposne.data.results.data == 'this_invoice_already_created'){
                    document.getElementById('addBTN').disabled = false;
                    document.getElementById('HideInvoice').click();
                    this.resetInvoice();
                }else{

                    document.getElementById('addBTN').disabled = false;
                    if (this.$snotify.notifications.length > 0) {
                        this.$snotify.notifications.forEach(notification => {
                            this.$snotify.remove(notification.id)
                        });
                    }
                    let message = this.lang.invoice_added;
                    this.$snotify.error(message, this.lang.alert, {
                        timeout: 1000000,
                        showProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        position: SnotifyPosition.centerCenter,
                        buttons: [
                            {
                                text: this.lang.close,
                                action: (toast) => {
                                    this.$snotify.remove(toast.id);
                                }
                            },
                        ]
                    });


                    this.printPDF(resposne.data.results.data.results.newID);
                    document.getElementById('HideInvoice').click();


                    if(this.showClientTypeRow){
                        if(this.cardid && this.cardid != 0){
                            this.$parent.getCard(this.cardid);
                            this.$parent.$parent.getCurrentCards(this.cardid);

                            document.getElementById('closecardview').click();
                        }
                        else{
                            this.$parent.getCurrentCards();
                        }
                    }else{
                        // this.$parent.getCustomerInfo();
                    }

                    this.cars = [{
                        c1: '',
                        c2: '',
                        c3: '',
                        text: '',
                        plate_number: '',
                        color: '',
                        model: '',
                        made_year: '',
                        workdes: '',
                        vin: '',
                        engine_meter: '',
                        next_oil_change: '',
                        brand: '',
                    }]
                    this.cars[0].plate_number = '';
                    this.getCar('', 0);
                    // this.$parent.getCustomerInfo();
                }
                this.reset();

            }).catch((error) => {
                const button = document.getElementById('addBTN');
                if (button) button.disabled = false;
                this.$store.state.showLoading = false;
                if (error.message === 'zatca_check_failed') return;
                const response = error.response && error.response.data;
                const code = response && response.error && response.error.code;
                const ar = this.lang.langname === 'ar';
                const messages = {
                    invoice_schema_not_ready: ar ? 'لم يتم حفظ الفاتورة. يلزم تحديث إعدادات قاعدة البيانات.' : 'Invoice was not saved. The database needs its invoice update.',
                    invoice_accounts_not_ready: ar ? 'لم يتم حفظ الفاتورة. يرجى استكمال ربط حسابات المبيعات والضريبة وطريقة الدفع.' : 'Invoice was not saved. Check the sales, tax and payment account mappings.',
                    invoice_posting_failed: ar ? 'لم يتم حفظ الفاتورة. تعذر ترحيل القيد أو حركة المخزون. راجع الحسابات وتكلفة الأصناف والمخزون.' : 'Invoice was not saved. Accounting or stock posting failed. Check account mappings, item costs and stock.',
                    invoice_input_invalid: ar ? 'لم يتم حفظ الفاتورة. يرجى التحقق من بيانات العميل والإجماليات والأصناف.' : 'Invoice was not saved. Check customer details, totals and line items.',
                    invoice_line_invalid: ar ? 'لم يتم حفظ الفاتورة. تحقق من وصف الصنف والكمية والأسعار.' : 'Invoice was not saved. Check item descriptions, quantities and prices.'
                };
                const message = messages[code] || (ar
                    ? 'تعذر تأكيد حفظ الفاتورة. راجع قائمة الفواتير قبل المحاولة مرة أخرى. تم الاحتفاظ بالبيانات المدخلة.'
                    : 'Could not confirm the invoice was saved. Check the invoice list before retrying. Your entered details have been kept.');
                this.$snotify.error(message, this.lang.alert, {
                    timeout: 0, showProgressBar: false, closeOnClick: true,
                    position: SnotifyPosition.centerCenter
                });
            });
        },
        printInvo(id){
            window.open('../api/print.php?invid='+id,'_blank');
        },
        printPDF (id)
        {
            let pdfFrame = document.body.appendChild(document.createElement('iframe'));
            pdfFrame.style.display = 'none';
            pdfFrame.onload = () => (void pdfFrame.contentWindow.print());
            pdfFrame.src = '../api/print.php?invid='+id;
        },
        changePtype(){
            // let tbs = [];
            //  if(this.tbrows.length != 0){
            //     for(let i = 0; i < this.tbrows.length; i++){
            //         let fftotal = parseFloat(this.tbrows[i].item_price) * parseFloat(this.tbrows[i].qty);
            //         fftotal = this.$RoundNum(fftotal);
            //         const vs = this.$calcVat(fftotal,this.invoice.vtype);
            //         const itm = {
            //             item_name: this.tbrows[i].item_name,
            //             qty: this.tbrows[i].qty,
            //             item_price: this.tbrows[i].item_price,
            //             total: vs.tot,
            //             vat: vs.vat,
            //             ftotal: vs.ftot
            //         }
            //         tbs.push(itm);
            //     }
            // }
            // this.tbrows = tbs;
            // this.calcAll();
            // this.calcKit();
        },
        recalcTbrows(){
            // alert(this.tbrows[0].vat_rate)
            // console.log();
            for(let i=0;i < this.tbrows.length;i++){
                // this.tbrows[i].vat_rate = 15;
                // console.log(this.tbrows[i])
                const vt = this.invoice.vtype;
                const price = +this.tbrows[i].item_price * +this.tbrows[i].qty;
                // alert(vt);
                if(this.tbrows[i].vat_rate == 0){
                    this.tbrows[i].total = this.$RoundNum(price,2);
                    this.tbrows[i].ftotal = this.$RoundNum(price,2);
                    this.tbrows[i].vat = this.$RoundNum(0,2);
                }else{
                    const vat = this.$calcVat(price,vt,this.tbrows[i].vat_rate);
                    this.tbrows[i].total = this.$RoundNum(vat.tot,2);
                    this.tbrows[i].ftotal = this.$RoundNum(vat.ftot,2);
                    this.tbrows[i].vat = this.$RoundNum(vat.vat,2);
                }

            }
            for(let i=0;i < this.tbrows1.length;i++){
                const vt1 = this.invoice.vtype;
                const price1 = +this.tbrows1[i].item_price * +this.tbrows1[i].qty;

                const vat1 = this.$calcVat(price1,vt1);
                this.tbrows1[i].total = this.$RoundNum(vat1.tot,2);
                this.tbrows1[i].ftotal = this.$RoundNum(vat1.ftot,2);
                this.tbrows1[i].vat = this.$RoundNum(vat1.vat,2);
            }
        },
        changeVatType(){
            this.recalcTbrows();
            this.calcKit();
            this.calcKit1();
            this.calcAll();
        },
        calcAll(){
            // this.full_total = 0;
            // this.full_vat = 0;
            // this.full_ftotal = 0;
            // if(this.tbrows.length != 0){
            //     for(let i = 0; i < this.tbrows.length; i++){
            //         this.full_total = parseFloat(this.nsp.total) + parseFloat(this.tbrows[i].total);
            //         this.full_vat = parseFloat(this.nsp.ftotal) + parseFloat(this.tbrows[i].vat);
            //         this.full_ftotal = parseFloat(this.nsp.vat) + parseFloat(this.tbrows[i].ftotal);
            //     }
            // }
            // if(this.spareparts.length != 0){
            //     for(let i = 0; i < this.spareparts.length; i++){
            //         this.full_total = parseFloat(this.full_total) + parseFloat(this.spareparts[i].total);
            //         this.full_vat = parseFloat(this.full_vat) + parseFloat(this.spareparts[i].vat);
            //         this.full_ftotal = parseFloat(this.full_ftotal) + parseFloat(this.spareparts[i].ftotal);
            //     }
            // }
            // let discount = this.invoice.discount;
            // if(discount == '') discount = 0;
            // if(this.$store.state.licenseType.perDiscount){
            //     if(this.invoice.discount > 30) this.invoice.discount = 30;
            //     discount = parseFloat(this.invoice.discount) * parseFloat(this.full_total) / parseFloat(100);
            // }
            // if(discount > this.full_ftotal/2){
            //     discount = this.full_ftotal/2;
            // }
            // // alert(discount);
            // if(discount != 0){
            //     // this.invoice.t_discount = parseFloat(this.invoice.discount) * parseFloat(this.full_total) / parseFloat(100);
            //     this.invoice.t_discount = parseFloat(discount);
            //     this.full_total = parseFloat(this.full_total) - this.invoice.t_discount;
            //     //* mohammed
            //     const vatic = this.$calcVat(this.full_total,this.invoice.vtype)
            //     this.full_vat = vatic.vat;
            //     this.full_ftotal = vatic.ftot;
            // }
            // this.full_total = this.$RoundNum(this.full_total);
            // this.full_vat = this.$RoundNum(this.full_vat);
            // this.full_ftotal = this.$RoundNum(this.full_ftotal);
            // if(this.invoice.paytype == 1 || this.invoice.paytype == 3){
            //     this.invoice.payment.cash = this.full_ftotal;
            //     this.invoice.payment.span = 0;
            // }else if(this.invoice.paytype == 2){
            //     this.invoice.payment.cash = '';
            //     this.invoice.payment.span = this.full_ftotal;
            // }
            // if(this.invoice.invtype == 2){
            //     this.invoice.payment.cash = '';
            //     this.invoice.payment.span = 0;
            // }
        },
        InvType () {
            if(this.invoice.invtype == 1){
                if(this.paytype == 1){
                    this.invoice.payment.cash = this.full_ftotal;
                    this.payment.span = 0;
                }else{
                    this.invoice.payment.span = this.full_ftotal;
                    this.invoice.payment.cash = '';
                }
            }else{
                this.invoice.payment.span = 0;
                this.invoice.payment.cash = '';
            }
        },
        removeItem(item){
            this.tbrows.splice(item, 1);
            this.calcAll()
        },
        removeItem1(item){
            this.tbrows1.splice(item, 1);
            this.calcAll()
        },
        calcKit() {
            const vt = this.invoice.vtype;
            const price = +this.newrow.item_price * +this.newrow.qty;
            if(this.newrow.vat_rate == 0){
                this.newrow.total = this.$RoundNum(price);
                this.newrow.ftotal = this.$RoundNum(price);
                this.newrow.vat = this.$RoundNum(0);
                if(this.price != ''){
                    this.addNewRow();
                }
                return false;
            }else{
                const vat = this.$calcVat(price,vt,this.newrow.vat_rate);
                this.newrow.total = this.$RoundNum(vat.tot);
                this.newrow.ftotal = this.$RoundNum(vat.ftot);
                this.newrow.vat = this.$RoundNum(vat.vat);
                if(this.price != ''){
                    this.addNewRow();
                }
            }
        },
        calcKit1() {
            const vt = this.invoice.vtype;
            const price = +this.newrow1.item_price * +this.newrow1.qty;
            const vat = this.$calcVat(price,vt);
            this.newrow1.total = this.$RoundNum(vat.tot);
            this.newrow1.ftotal = this.$RoundNum(vat.ftot);
            this.newrow1.vat = this.$RoundNum(vat.vat);
            if(this.price != ''){
                this.addNewRow1();
            }
        },
        addNewRow() {
            console.log(this.newrow);
            if (this.$snotify.notifications.length > 0) {
                this.$snotify.notifications.forEach(notification => {
                    this.$snotify.remove(notification.id)
                });
            }
            if(this.newrow.item_name == ''){
                // let message = lang.can_not_add_item_withoud_discription;
                // this.$snotify.error(message, lang.alert, {
                //     timeout: 1000000,
                //     showProgressBar: false,
                //     closeOnClick: true,
                //     pauseOnHover: true,
                //     position: SnotifyPosition.centerCenter,
                //     buttons: [
                //         {
                //             text: lang.close,
                //             action: (toast) => {
                //                 this.$snotify.remove(toast.id);
                //             }
                //         },
                //     ]
                // });
                return false;
            }
            if(this.newrow.qty == '' || this.newrow.qty == 0){
                // let message = lang.item_qtty_must_be_more_than_zero;
                // this.$snotify.error(message, lang.alert, {
                //     timeout: 1000000,
                //     showProgressBar: false,
                //     closeOnClick: true,
                //     pauseOnHover: true,
                //     position: SnotifyPosition.centerCenter,
                //     buttons: [
                //         {
                //             text: lang.close,
                //             action: (toast) => {
                //                 this.$snotify.remove(toast.id);
                //             }
                //         },
                //     ]
                // });
                return false;
            }
            if(!this.$store.state.zeroPrice){

                if(this.newrow.item_price == '' || this.newrow.item_price == 0){
                    // let message = lang.item_price_must_be_more_than_zero;
                    // this.$snotify.error(message, lang.alert, {
                    //     timeout: 1000000,
                    //     showProgressBar: false,
                    //     closeOnClick: true,
                    //     pauseOnHover: true,
                    //     position: SnotifyPosition.centerCenter,
                    //     buttons: [
                    //         {
                    //             text: lang.close,
                    //             action: (toast) => {
                    //                 this.$snotify.remove(toast.id);
                    //             }
                    //         },
                    //     ]
                    // });

                    return false;
                }
            }
            this.newrow.empname = "";
            for(let i=0;i<this.unites.length;i++){
                if(this.unites[i].id == this.newrow.unitid){
                    this.newrow.unitname = this.unites[i][`name${ this.lang.langname}`]
                }
            }

            this.tbrows.push(this.newrow);
            this.newrow = {
                itemcode: '',
                item_type: 2,
                item_name: '',
                qty: 1,
                unitid: 1,
                unitname: 'Item',
                item_price: '',
                total: '',
                vat: '',
                ftotal: '',
                extra1: '',
                extra2: '',
                extra3: '',
                type: 'service',
                plate_number: this.newrow.plate_number,
                type_of_item: this.newrow.type_of_item ?? 1,
                vat_rate: this.$store.state.settings.def_vat
            }
            this.calcAll()
        },
        addNewRow1() {
            if (this.$snotify.notifications.length > 0) {
                this.$snotify.notifications.forEach(notification => {
                    this.$snotify.remove(notification.id)
                });
            }
            if(this.newrow1.item_name == ''){
                // let message = lang.can_not_add_item_withoud_discription;
                // this.$snotify.error(message, lang.alert, {
                //     timeout: 1000000,
                //     showProgressBar: false,
                //     closeOnClick: true,
                //     pauseOnHover: true,
                //     position: SnotifyPosition.centerCenter,
                //     buttons: [
                //         {
                //             text: lang.close,
                //             action: (toast) => {
                //                 this.$snotify.remove(toast.id);
                //             }
                //         },
                //     ]
                // });
                return false;
            }
            if(this.newrow1.qty == '' || this.newrow1.qty == 0){
                // let message = lang.item_qtty_must_be_more_than_zero;
                // this.$snotify.error(message, lang.alert, {
                //     timeout: 1000000,
                //     showProgressBar: false,
                //     closeOnClick: true,
                //     pauseOnHover: true,
                //     position: SnotifyPosition.centerCenter,
                //     buttons: [
                //         {
                //             text: lang.close,
                //             action: (toast) => {
                //                 this.$snotify.remove(toast.id);
                //             }
                //         },
                //     ]
                // });
                return false;
            }
            if(!this.$store.state.zeroPrice){

                if(this.newrow1.item_price == '' || this.newrow1.item_price == 0){
                    // let message = lang.item_price_must_be_more_than_zero;
                    // this.$snotify.error(message, lang.alert, {
                    //     timeout: 1000000,
                    //     showProgressBar: false,
                    //     closeOnClick: true,
                    //     pauseOnHover: true,
                    //     position: SnotifyPosition.centerCenter,
                    //     buttons: [
                    //         {
                    //             text: lang.close,
                    //             action: (toast) => {
                    //                 this.$snotify.remove(toast.id);
                    //             }
                    //         },
                    //     ]
                    // });

                    return false;
                }
            }
            this.tbrows1.push(this.newrow1);
            this.newrow1 = {
                itemcode: '',
                item_name: '',
                qty: 1,
                unitid: 1,
                unitname: 'Item',
                item_price: '',
                total: 0,
                vat: 0,
                ftotal: 0,
                plate_number: this.newrow.plate_number,
                type: 'sparepart',
            }
            this.calcAll()
        },
        changeCtype() {
            if(this.customer.cctype == 2){
                this.showcamp = true;
            }else{
                this.showcamp = false;
            }
        },
        getInvSettings() {
            if(this.$store.state.settings.vat_number == ''){
                this.invoice.vtype = 1;
            }
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','getInvSettings');
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[all]','all');
            return axios.post(
                this.$SAMCOTEC.r_path, post
            ).then(
                (response) => {
                    const res = response.data;
                    this.unites = res.results.unites;
                    if(res != '' && res.error.number == 200){
                        if(res.results.data.users.length != 0){
                            for(let i= 0; i < res.results.data.users.length; i++){
                                this.invoice.users.push({
                                    text: res.results.data.users[i].full_name,
                                    value: res.results.data.users[i].id
                                })
                            }
                        }
                        if(res.results.data.desk.length != 0){
                            this.itemsworkdes = [];
                            this.allDesc = res.results.data.desk;
                            for(let i= 0; i < res.results.data.desk.length; i++){
                                this.itemsworkdes.push(res.results.data.desk[i].title);
                            }
                        }
                        if(res.results.data.products.length != 0){
                            this.spareparts = [];
                            this.allProducts = res.results.data.products;
                            this.spareparts = res.results.data.products
                            // for(let i= 0; i < res.results.data.products.length; i++){
                            //     this.spareparts.push(res.results.data.products[i].name);
                            // }
                        }
                        // Deliberately NOT seeded with the full product list any more --
                        // searchItemsLazy() fills this as the operator types. allProducts and
                        // spareparts below still hold the preloaded set, which other logic in
                        // this component reads; unpicking that is a separate step.
                        this.itemsworkdes = [];
                    }
                }
            )
        },

        normalizeItemCode(value) {
            if (value === null || value === undefined) {
                return '';
            }

            const itemcode = String(value).trim();
            return ['null', 'undefined'].includes(itemcode.toLowerCase()) ? '' : itemcode;
        },
        getTbrowItemCode(row){
            const current = this.normalizeItemCode(row.itemcode || row.item_code || row.item_number);
            const itemid = row.itemid !== undefined && row.itemid !== null ? row.itemid : '';
            if(current !== '') return current;
            if(itemid === '') return '';

            const sources = [];
            if(Array.isArray(this.allProducts)) sources.push(...this.allProducts);
            if(Array.isArray(this.allDesc)) sources.push(...this.allDesc);
            if(Array.isArray(this.itemsworkdes)) sources.push(...this.itemsworkdes);
            if(Array.isArray(this.spareparts)) sources.push(...this.spareparts);

            for(let i=0;i<sources.length;i++){
                const p = sources[i] || {};
                const ids = [p.id, p.productid, p.product_id, p.item_id, p.itemid, p.item_code, p.itemcode];
                if(ids.some((value) => value !== undefined && value !== null && String(value) === String(itemid))){
                    return this.normalizeItemCode(p.item_code || p.itemcode || p.item_number);
                }
            }

            return '';
        },
        fillTbrowsItemCodes(){
            const fillFor = (rows) => {
                if(!Array.isArray(rows)) return;
                for(let i=0;i<rows.length;i++){
                    const r = rows[i];
                    const current = this.normalizeItemCode(r.itemcode || r.item_code || r.item_number);
                    const itemcode = current || this.getTbrowItemCode(r);
                    if(r.itemcode !== itemcode){
                        this.$set(rows, i, {...r, itemcode});
                    }
                }
            }
            fillFor(this.tbrows);
            fillFor(this.tbrows1);
        },
        getAllName(id){
            // this.customer.mobile = "";
            if(this.customer.customerid != ''){
                return false;
            }
            this.customer.customerid = "";
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','customerInfoAll');
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[mobile]',this.customer.mobile);
            post.append('data[customerid]',this.customer.customerid);
            post.append('data[customer_type]',this.customer.cctype);
            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then(
                (response) => {
                    const res = response.data;
                    this.customersList = res.results.data;
                    if(this.customersList.length == 0){
                        this.syncCustomerCars(null);
                        return false;
                    }
                    // if(this.customer.customerid != ''){
                        this.company = {
                            fullname: typeof res.results.data[0] !== 'undefined' ? res.results.data[0].company_name : '',
                            vatid: typeof res.results.data[0] !== 'undefined' ? res.results.data[0].company_vatid : '',
                            projectname: typeof res.results.data[0] !== 'undefined' ? res.results.data[0].projectname : '',
                            building_no: typeof res.results.data[0] !== 'undefined' ? res.results.data[0].building_no : '',
                            street_name: typeof res.results.data[0] !== 'undefined' ? res.results.data[0].street_name : '',
                            branch_number: typeof res.results.data[0] !== 'undefined' ? res.results.data[0].branch_number : '',
                            district: typeof res.results.data[0] !== 'undefined' ? res.results.data[0].district : '',
                            zipcode: typeof res.results.data[0] !== 'undefined' ? res.results.data[0].zipcode : '',
                            city: typeof res.results.data[0] !== 'undefined' ? res.results.data[0].city : '',
                            address: typeof res.results.data[0] !== 'undefined' ? res.results.data[0].address : '',
                            crt_number: typeof res.results.data[0] !== 'undefined' ? res.results.data[0].crt_number : '',
                            entity_name: typeof res.results.data[0] !== 'undefined' ? res.results.data[0].entity_name : '',
                            branch_name: typeof res.results.data[0] !== 'undefined' ? res.results.data[0].branch_name : '',
                            entity_branch_number: '',
                            request_number: "",
                            po_number: "",
                            po_date: "",
                        }
                        this.customer = {
                            id: res.results.data[0].id,
                            customerid: res.results.data[0].id,
                            mobile: res.results.data[0].mobile,
                            full_name: res.results.data[0].full_name,
                            cctype: res.results.data[0].customer_type
                        }
                        this.changeCusType(parseFloat(res.results.data[0].customer_type) - 1)
                        this.syncCustomerCars(res.results.data[0]);
                    // }
                }
            )
        },
        getAllNameById(id){
            this.customer.mobile = "";
            // this.customer.customerid = "";
            const post = new FormData();
            // alert(this.customer.customerid)
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','customerInfoAll');
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[mobile]',this.customer.mobile ? this.customer.mobile : '');
            post.append('data[customerid]',this.customer.customerid);
            post.append('data[customer_type]',this.customer.customer_type);
            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then(
                (response) => {
                    const res = response.data;
                    this.customersList = res.results.data;
                    if(!Array.isArray(this.customersList) || this.customersList.length == 0){
                        this.syncCustomerCars(null);
                        return false;
                    }

                    // if(this.customer.customerid != ''){
                        this.company = {
                            fullname: typeof res.results.data[0] !== 'undefined' ? res.results.data[0].company_name : '',
                            vatid: typeof res.results.data[0] !== 'undefined' ? res.results.data[0].company_vatid : '',
                            projectname: typeof res.results.data[0] !== 'undefined' ? res.results.data[0].projectname : '',
                            building_no: typeof res.results.data[0] !== 'undefined' ? res.results.data[0].building_no : '',
                            street_name: typeof res.results.data[0] !== 'undefined' ? res.results.data[0].street_name : '',
                            branch_number: typeof res.results.data[0] !== 'undefined' ? res.results.data[0].branch_number : '',
                            district: typeof res.results.data[0] !== 'undefined' ? res.results.data[0].district : '',
                            zipcode: typeof res.results.data[0] !== 'undefined' ? res.results.data[0].zipcode : '',
                            city: typeof res.results.data[0] !== 'undefined' ? res.results.data[0].city : '',
                            address: typeof res.results.data[0] !== 'undefined' ? res.results.data[0].address : '',
                            crt_number: typeof res.results.data[0] !== 'undefined' ? res.results.data[0].crt_number : '',
                            entity_name: typeof res.results.data[0] !== 'undefined' ? res.results.data[0].entity_name : '',
                            branch_name: typeof res.results.data[0] !== 'undefined' ? res.results.data[0].branch_name : '',
                            entity_branch_number: '',
                            request_number: "",
                            po_number: "",
                            po_date: "",
                        }
                        this.customer = {
                            id: res.results.data[0].id,
                            customerid: res.results.data[0].id,
                            mobile: res.results.data[0].mobile,
                            full_name: res.results.data[0].full_name,
                            cctype: res.results.data[0].customer_type
                        }
                        this.changeCusType(parseFloat(res.results.data[0].customer_type) - 1)
                        this.syncCustomerCars(res.results.data[0]);
                    // }
                }
            )
        },
        getName(id){
            this.customersList = [];
            this.getAllName();
            // if(id == 0){
            //     this.customer.mobile = '';
            // }else{
            //     this.customer.customerid = "";
            // }
            // const post = new FormData();
        //     post.append('defBranch',localStorage.getItem('defBranch'));
        //   post.append('financeYear',localStorage.getItem('financeYear'));
            // post.append('type','customerInfo');
            // post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            // post.append('data[mobile]',this.customer.mobile);
            // post.append('data[customerid]',this.customer.customerid);
            // axios.post(
            //     this.$SAMCOTEC.r_path, post
            // ).then(
            //     (response) => {
            //         const res = response.data;

            //         if(res.error.number == 200){
            //             this.customer.id = res.results.data['id'];
            //             this.customer.mobile = res.results.data['mobile'];
            //             this.customer.full_name = res.results.data['full_name'];
            //             this.customer.customerid = res.results.data['customerid'];
            //             this.company.fullname = res.results.data['company_name'];
            //             this.company.vatid = res.results.data['company_vatid'];
            //             this.company.crt_number = res.results.data['crt_number'];
            //             this.company.address = res.results.data['address'];
            //             this.company.city = res.results.data['city'];
            //             this.company.zipcode = res.results.data['zipcode'];
            //             this.company.district = res.results.data['district'];
            //             this.company.branch_number = res.results.data['branch_number'];
            //             this.company.street_name = res.results.data['street_name'];
            //             this.company.building_no = res.results.data['building_no'];
            //             this.company.entity_name = res.results.data['entity_name'];
            //             this.company.entity_branch_number = res.results.data['entity_branch_number'];
            //             if(this.company.address == 'undefined' || this.company.address == ''){
            //                 this.company.address = this.company.building_no != '' ? this.company.building_no + "," : '';
            //                 this.company.address += this.company.street_name != '' ? this.company.street_name + " " : '';
            //                 this.company.address += (this.company.branch_number != '' && this.company.zipcode != '') ? this.company.branch_number + " - " + this.company.zipcode + ", " :'';
            //                 this.company.address += this.company.district + " - "+ this.company.city;
            //             }
            //         }
            //     }
            // )
        },
        getPyamentType(){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','getPayTypes');
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[id]',"all");
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                const res = response.data;
                this.payTypeOp = [];
                for(let i=0;i<res.results.data.length;i++){
                    this.invoice.paytypes.push({
                        text: this.lang.langname == 'ar' ? res.results.data[i].type_name : res.results.data[i].type_name_en,
                        value: res.results.data[i].id
                    })
                }
                // this.paytypeOp = t;

                this.invoice.paytype = res.results.data[0].id;
            })
        },
        getCar(plate_number,index){
            if(plate_number == ''){
                this.cars = [{
                    c1: '',
                    c2: '',
                    c3: '',
                    text: '',
                    plate_number: '',
                    color: '',
                    model: '',
                    made_year: '',
                    workdes: '',
                    vin: '',
                    engine_meter: '',
                    next_oil_change: '',
                    brand: '',
                }];
                return false;
            }
            plate_number = this.cars[index].plate_number;
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','carInfo');
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[plate_number]',this.cars[index].plate_number);
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then(
                (response) => {
                    const res = response.data;
                    let cars = [];
                    if(res.error.number == 200){
                        let c = res.results.data.plate_number.split(" ")
                        let car = {
                            c1: c[0],
                            c2: c[1],
                            c3: c[2],
                            text: c[3],
                            plate_number: res.results.data.plate_number != '' ? res.results.data.plate_number : this.car.plate_number,
                            made_year:res.results.data.made_year != '' ? res.results.data.made_year : this.car.made_year,
                            model:res.results.data.model != '' ? res.results.data.model : this.car.model,
                            vin:res.results.data.vin != '' ? res.results.data.vin : this.car.vin,
                            id:res.results.data.id ,
                            color:res.results.data.color != '' ? res.results.data.color : this.car.color,
                            brand:res.results.data.brand != '' ? res.results.data.brand : this.car.brand,
                        }
                        this.newrow.plate_number = res.results.data.plate_number;
                        // this.updateCars(car);
                        this.cars[index] = car;

                        this.addNewCar();
                        this.cars.pop()
                        this.checkContractForCar(res.results.data.plate_number);
                    }else{
                        this.newrow.plate_number = plate_number;
                        let c = this.newrow.plate_number.split(" ")
                        let car = {
                            c1: c[0],
                            c2: c[1],
                            c3: c[2],
                            text: c[3],
                            plate_number:plate_number,
                            made_year:'',
                            model:'',
                            vin:'',
                            id:'',
                            color:'',
                            brand:'',
                        }
                        this.cars[index] = car;
                        this.addNewCar();
                        this.cars.pop()
                    }
                }
            )
        },
        checkContractForCar(plate_number){
            if(!plate_number) return;
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","getActiveContractForCar");
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[plate_number]',plate_number);
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                const data = response && response.data && response.data.results ? response.data.results.data : null;
                if(data && data.contract_id){
                    this.contract_id = data.contract_id;
                    this.contractOfferedItems = data.items || [];
                    this.contractAutoDetected = true;
                }else{
                    this.contractOfferedItems = [];
                    // Only clear contract_id if WE were the ones who set it --
                    // never stomp a value that arrived some other way (see the
                    // contractAutoDetected comment in data()).
                    if(this.contractAutoDetected){
                        this.contract_id = 0;
                    }
                }
            });
        },
        addContractItem(item){
            this.newrow.itemcode = item.item_code;
            this.newrow.item_name = item.item_name;
            this.newrow.item_price = item.item_price;
            this.newrow.qty = 1;
            this.calcKit();
        },
    },
    // watch: {
    //     // whenever question changes, this function will run
    //     cars(oldvalues, newvalues) {
    //         if (newvalues.includes('?')) {
    //             //this.getAnswer()
    //             this.updateCars()
    //             // console.log("oldvalue",oldvalues);
    //         }
    //     }
    // },
}
</script>
<style>
.dispFlex{
    display:flex;
    flex-direction: row;
    justify-content: center !important;
    padding-left:10px;
    padding-right:10px;
    justify-items: center;
    align-items: center;
}
.boDry:hover{
    background:green !important;
}
.addCar{
    display:flex;
    flex-direction: row;
    justify-content: space-between;
}
.tobbuttom {
    display: flex;
    flex-direction: row;
    justify-content: center;
    justify-items: center;
    align-items: center;
}
.redColor {
    background: red!important;
    color: #fff!important;
}
.weightColor {
    background: #fff !important;
    color: #000 !important;
}
.borderRad_none, .borderRad_right {
    border-top-left-radius: 0 0!important;
    border-bottom-left-radius: 0 0!important;
    padding: 5px 10px!important;
    font-size: .8rem!important;
}
.hideme{
    display:none !important;
}
.borderRad_none {
    border-top-right-radius: 0 0!important;
    border-bottom-right-radius: 0 0!important;
}
.borderRad_left {
    border-top-left-radius: 5px 5px!important;
    border-bottom-left-radius: 5px 5px!important;
    border-top-right-radius: 0!important;
    border-bottom-right-radius: 0!important;
    padding: 5px 10px!important;
    font-size: .8rem!important;
    -webkit-margin-start: 5px!important;
    margin-inline-start: 5px!important;
}
.flexTay{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    justify-items: center;
}
.flexTay select{
    margin-inline-end: 2px;
}
.invoice-tab-wrap{
    display:flex;
    flex-wrap:wrap;
    justify-content:center;
    gap:8px;
    margin:12px 0;
}
.invoice-tab-btn{
    min-width:240px;
    width:240px;
}
@media screen and (max-width: 1100px) {
    .tobbuttom{
      flex-direction: column !important;
      gap:3px;
    }
  }
@media screen and (max-width: 576px) {
    .invoice-tab-btn{
        min-width:100%;
        width:100%;
    }
}
</style>
